export type Language = 'zh-CN' | 'en-US';

export const messages: Record<Language, Record<string, string>> = {
  'zh-CN': {
    // ===== 通用 =====
    'common.search': '搜索',
    'common.back': '返回',
    'common.cancel': '取消',
    'common.confirm': '确认',
    'common.close': '关闭',
    'common.refresh': '刷新',
    'common.loading': '加载中...',
    'common.unknown': '未知',
    'common.pleaseLogin': '请先登录',
    'common.operationFailed': '操作失败',
    'common.submitFailed': '提交失败',
    'common.yes': '是',
    'common.no': '否',

    // ===== 导航 =====
    'nav.home': '首页',
    'nav.tools': 'AI工具库',
    'nav.profile': '个人中心',
    'nav.logout': '退出登录',
    'nav.login': '登录',
    'nav.register': '注册',
    'nav.deals': '优惠',
    'nav.submit': '提交工具',
    'nav.admin': '后台管理',

    // ===== 页脚 =====
    'footer.desc': '按任务选 AI 工具，并标注国内能否直连',
    'footer.contact': '联系我们',
    'footer.privacy': '隐私政策',
    'footer.terms': '服务条款',
    'footer.disclaimer': '免责声明',
    'footer.submit': '纠错/提交工具',
    'footer.feedback': '意见反馈',
    'footer.legalNotice': '本平台依据中华人民共和国网络安全法运营',

    // ===== 首页 =====
    'home.heroTitle': '按任务选 AI 工具',
    'home.heroSub': '先看场景，再看国内能不能直连。少踩镜像站和过时价格。',
    'home.heroSubWithCats': '选型短文 + 中国可用性标注 · {catCount} 个分类可筛',
    'home.searchPlaceholder': '搜索任务或工具…例如：出图、写代码、会议纪要',
    'home.featured': '精选推荐',
    'home.jobsTitle': '按任务进入',
    'home.recommend': '为你推荐',
    'home.byCategory': '按分类浏览',
    'home.allCategories': '全部分类',
    'home.viewAll': '查看全部',
    'home.toolCount': '{count} 个工具',
    'home.browseAllCategories': '浏览全部分类',
    'home.browseAll': '进入工具库',

    // ===== 定价 =====
    'pricing.free': '免费',
    'pricing.freemium': '免费增值',
    'pricing.paid': '付费',
    'pricing.contact': '联系定价',

    // ===== 工具列表 =====
    'tools.filter': '筛选',
    'tools.clearFilter': '清除筛选',
    'tools.clearAll': '清除全部',
    'tools.resetFilter': '重置',
    'tools.category': '分类',
    'tools.searchCategory': '搜索分类...',
    'tools.pricing': '定价类型',
    'tools.pricingAll': '全部',
    'tools.searchPlaceholder': '搜索AI工具...',
    'tools.searchFullPlaceholder': '搜索 AI 工具名称、描述、标签...',
    'tools.totalFound': '当前列表 {count} 条',
    'tools.narrowHint': '先用左侧筛选或首页任务入口选型，再浏览列表',
    'tools.noResult': '没有找到匹配的工具',
    'tools.noResultSearch': '未找到与「{keyword}」相关的工具',
    'tools.noResultGeneric': '暂无符合条件的工具',
    'tools.recentSearch': '最近搜索',
    'tools.clearHistory': '清空历史',
    'tools.noRating': '暂无评分',
    // 排序
    'tools.sortHotScore': '🔥 热度排行',
    'tools.sortFunding': '💰 融资规模',
    'tools.sortViewCount': '👁 使用量',
    'tools.sortRating': '⭐ 综合评分',
    'tools.sortNewest': '最新上架',
    'tools.sortReviewCount': '评价数量',
    'tools.sortName': '名称 A-Z',
    'tools.sortCompliance': '合规评分',

    // ===== 工具详情 =====
    'detail.visitSite': '访问官网',
    'detail.favorite': '收藏',
    'detail.favorited': '已收藏',
    'detail.unfavorited': '已取消收藏',
    'detail.favoriteSuccess': '已收藏',
    'detail.description': '详细介绍',
    'detail.reviews': '用户评价',
    'detail.submitReview': '提交评价',
    'detail.updateReview': '更新评价',
    'detail.cancelEdit': '取消编辑',
    'detail.featured': '精选',
    'detail.uncategorized': '未分类',
    'detail.noRating': '暂无评分',
    'detail.notFound': '工具不存在或已下架',
    'detail.toolNotExist': '工具不存在',
    'detail.reviewUpdated': '评价更新成功',
    'detail.reviewSubmitted': '评价提交成功',
    'detail.noScreenshot': '暂无网站截图',
    'detail.sourceEntry': '原始条目',
    'detail.reviewCount': '{count} 条评价',
    'detail.viewCount': '{count} 次浏览',
    'detail.ratingLabel': '评分',
    'detail.ratingRequired': '请选择评分',
    'detail.reviewTitleLabel': '标题',
    'detail.reviewTitleRequired': '请输入评价标题',
    'detail.reviewTitlePlaceholder': '用一句话总结你的使用体验',
    'detail.reviewContentLabel': '评价内容',
    'detail.reviewContentRequired': '请输入评价内容',
    'detail.reviewContentMin': '评价不少于10个字符',
    'detail.reviewContentPlaceholder': '分享你的使用体验...',
    'detail.loginToReview': '后即可发表评价',
    'detail.anonymousUser': '匿名用户',
    'detail.editReview': '编辑评价',
    'detail.noReviews': '暂无评价，快来发表第一条评价吧！',
    'detail.productInfo': '产品信息',
    'detail.categoryLabel': '分类：',
    'detail.sourceLabel': '来源：',
    'detail.pricingLabel': '定价：',
    'detail.pricingDetail': '价格详情：',
    'detail.ratingInfoLabel': '评分：',
    'detail.reviewCountLabel': '评价数：',
    'detail.reviewCountSuffix': ' 条',
    'detail.viewCountLabel': '浏览量：',
    'detail.viewCountSuffix': ' 次',
    'detail.updatedAt': '更新于',
    'detail.supportsInvoice': '支持开具发票',
    'detail.supportsContract': '支持企业签约',
    'detail.supportsOnPrem': '支持私有化部署',
    'detail.channelReseller': '经销商',
    'detail.channelMarketplace': '云市场',
    'detail.channelOpenSource': '开源',
    'detail.channelDirect': '直接采购',
    'detail.devResources': '开发者资源',
    'detail.apiDoc': 'API 文档',
    'detail.correctFeedback': '纠错/反馈',
    'detail.complianceScoreTitle': '企业合规评分',
    'detail.visitWebsite': '访问网站',
    'detail.showcaseAlt': '{name} 展示图',
    'detail.complianceTooltip': '合规 {tier}',
    'detail.sectionKeyFeatures': '核心功能',
    'detail.sectionPricing': '定价方案',
    'detail.sectionUseCases': '使用场景',
    'detail.sectionTargetUsers': '目标用户',
    // 来源
    'source.topai': 'TopAI',
    'source.aicpb': 'AI工具集',
    'source.manual': '手动录入',
    'source.custom': '自定义来源',

    // ===== 合规 =====
    'tools.availabilityCN': '中国可用性',
    'tools.complianceTier': '合规等级',
    'tools.enterprise': '企业采购',
    'tools.supportsInvoice': '支持发票',
    'tools.supportsContract': '支持合同',
    'tools.supportsOnPrem': '支持私有部署',
    'tools.sortComplianceScore': '合规评分',
    'availability.direct': '可直连',
    'availability.vpn': '访问受限',
    'availability.mirror': '有镜像站',
    'availability.blocked': '不可用',
    'availability.cn_native': '国产服务',
    'availability.unknown': '待验证',
    'tier.T1_full': 'T1 完全合规',
    'tier.T2_partial': 'T2 部分合规',
    'tier.T3_none': 'T3 不合规',
    'tier.pending': '待评估',
    'status.passed': '已通过',
    'status.failed': '未通过',
    'status.in_progress': '进行中',
    'status.not_started': '未开始',
    'detail.chinaAvailability': '中国可用性',
    'detail.complianceRadar': '合规评分雷达',
    'detail.overallScore': '综合评分',
    'detail.enterpriseProcurement': '企业采购信息',
    'detail.cnUrl': '中国区地址',
    'detail.cnIcp': 'ICP 备案号',
    'detail.cnAppStore': '国区App Store',
    'detail.cnAppStoreAvailable': '已上架国内应用商店',
    'detail.cnWechat': '微信小程序',
    'detail.cnWechatAvailable': '有微信小程序',
    'detail.procurementChannel': '采购渠道',
    'detail.procurementContact': '采购联系方式',
    'detail.minSeats': '最低起购席位',
    'detail.enterpriseFeatures': '企业特性',
    'dim.data_residency': '数据驻留',
    'dim.privacy': '隐私保护',
    'dim.encryption': '加密传输',
    'dim.certification': '资质认证',
    'dim.content_moderation': '内容审核',
    'dim.audit_logging': '审计日志',
    'dim.sla_support': 'SLA与支持',
    'dim.export_control': '出口管制',

    // ===== 认证 =====
    'auth.welcomeBack': '欢迎回来',
    'auth.loginDesc': '登录你的 AI速览局账号',
    'auth.createAccount': '创建账号',
    'auth.registerDesc': '加入 AI速览局社区',
    'auth.loginSuccess': '登录成功',
    'auth.loginFailed': '登录失败，请检查邮箱和密码',
    'auth.registerSuccess': '注册成功，已自动登录',
    'auth.registerFailed': '注册失败，请重试',
    'auth.loggedOut': '已退出登录',
    'auth.emailLabel': '邮箱',
    'auth.emailRequired': '请输入邮箱',
    'auth.emailInvalid': '请输入有效的邮箱地址',
    'auth.passwordLabel': '密码',
    'auth.passwordRequired': '请输入密码',
    'auth.passwordMin': '密码至少6位',
    'auth.passwordPlaceholder': '请输入密码',
    'auth.usernameLabel': '用户名',
    'auth.usernameRequired': '请输入用户名',
    'auth.usernameLength': '用户名 2-30 个字符',
    'auth.usernamePattern': '支持中英文、数字和下划线',
    'auth.usernamePlaceholder': '你的用户名',
    'auth.passwordPlaceholderNew': '至少6位密码',
    'auth.confirmPasswordLabel': '确认密码',
    'auth.confirmPasswordRequired': '请确认密码',
    'auth.passwordMismatch': '两次输入的密码不一致',
    'auth.confirmPasswordPlaceholder': '再次输入密码',
    'auth.noAccount': '还没有账号？',
    'auth.goRegister': '注册新账号',
    'auth.hasAccount': '已有账号？',
    'auth.goLogin': '去登录',
    'auth.testAccount': '测试账号：',
    'auth.testAdmin': '管理员：',
    'auth.testUser': '用户：',
    // -- 手机验证码登录 --
    'auth.phoneLogin': '手机登录',
    'auth.emailLogin': '邮箱登录',
    'auth.phoneLabel': '手机号',
    'auth.phoneRequired': '请输入手机号',
    'auth.phoneInvalid': '请输入正确的手机号',
    'auth.phonePlaceholder': '请输入手机号',
    'auth.codeLabel': '验证码',
    'auth.codeRequired': '请输入验证码',
    'auth.codeLength': '验证码为6位数字',
    'auth.codePlaceholder': '6位验证码',
    'auth.sendCode': '获取验证码',
    'auth.codeSent': '验证码已发送',
    'auth.codeSendFailed': '发送验证码失败',
    // -- Google 登录 --
    'auth.googleLogin': '使用 Google 登录',
    'auth.googleLoginFailed': 'Google 登录失败',
    'auth.googleNotConfigured': '未配置',
    'auth.orLoginWith': '或',
    'auth.loggingIn': '正在登录...',
    'auth.autoRegisterHint': '未注册的手机号将自动创建账号',

    // ===== 个人中心 =====
    'profile.myFavorites': '我的收藏',
    'profile.noFavorites': '还没有收藏任何工具',
    'profile.discoverTools': '去发现工具',
    'profile.myReviews': '我的评价',
    'profile.unknownTool': '未知工具',
    'profile.noReviews': '还没有发表过评价',
    'profile.exploreTools': '去探索工具',
    'profile.settings': '账号设置',
    'profile.saveChanges': '保存修改',
    'profile.editProfile': '编辑资料',
    'profile.updateSuccess': '资料更新成功',
    'profile.updateFailed': '更新失败',
    'profile.roleAdmin': '管理员',
    'profile.roleUser': '用户',
    'profile.registeredAt': '注册于',

    // ===== 优惠 =====
    'deals.title': 'AI工具优惠',
    'deals.subtitle': '汇集全网最新AI工具折扣、促销和优惠码',
    'deals.searchPlaceholder': '搜索优惠...',
    'deals.sortPopular': '最受欢迎',
    'deals.sortDiscount': '折扣力度',
    'deals.sortNewest': '最新发布',
    'deals.sortExpiring': '即将到期',
    'deals.verifiedOnly': '仅已验证',
    'deals.verified': '已验证',
    'deals.totalFound': '共找到 {count} 个优惠',
    'deals.noResult': '暂无优惠信息',
    'deals.getDeal': '获取优惠',
    'deals.copyCoupon': '复制优惠码',
    'deals.couponCopied': '优惠码已复制',
    'deals.expiringToday': '今天到期',
    'deals.expiringDays': '还剩 {days} 天到期',
    'deals.upvoteFailed': '点赞失败',

    // ===== Admin Panel (后台管理系统) =====
    // -- 侧边栏 & 布局 --
    'adminPanel.title': '后台管理系统',
    'adminPanel.dashboard': '仪表盘',
    'adminPanel.users': '用户管理',
    'adminPanel.toolManage': '工具管理',
    'adminPanel.categories': '分类管理',
    'adminPanel.reviews': '评论管理',
    'adminPanel.feedback': '反馈管理',
    'adminPanel.submissions': '工具提交',
    'adminPanel.orders': '订单管理',
    'adminPanel.compliance': '合规管理',
    'adminPanel.stats': '数据统计',
    'adminPanel.backToSite': '返回前台',
    // -- Dashboard --
    'adminPanel.dashboardTitle': '管理面板概览',
    'adminPanel.totalTools': '工具总数',
    'adminPanel.activeTools': '活跃工具',
    'adminPanel.featuredTools': '精选工具',
    'adminPanel.totalUsers': '用户总数',
    'adminPanel.totalReviews': '评论总数',
    'adminPanel.totalFavorites': '收藏总数',
    'adminPanel.quickActions': '快捷操作',
    'adminPanel.exportTools': '导出工具',
    'adminPanel.exportUsers': '导出用户',
    'adminPanel.exportReviews': '导出评论',
    'adminPanel.exportCSV': '导出CSV',
    'adminPanel.opsSubtitle': '运营看板：网站管理 · 浏览量 · 业务 · 领域数据',
    'adminPanel.siteManageTitle': '网站管理',
    'adminPanel.siteManageNote': '通过后台与 Content API 随时修改工具、分类、素材等内容。',
    'adminPanel.contentApiDocs': 'Content API 文档',
    'adminPanel.assets': '资产管理',
    'adminPanel.trafficTitle': '浏览量（服务器日志）',
    'adminPanel.refreshTraffic': '重新汇总日志',
    'adminPanel.zhPvToday': '今日中文版 PV',
    'adminPanel.enPvToday': '今日英文版 PV',
    'adminPanel.eastPvToday': '今日华东地区 PV',
    'adminPanel.statDate': '日期',
    'adminPanel.zhPv': '中文版',
    'adminPanel.enPv': '英文版',
    'adminPanel.eastPv': '华东',
    'adminPanel.trafficEmpty': '暂无日志汇总数据（部署后由定时任务写入）',
    'adminPanel.trafficUnavailable': '流量接口暂不可用，请确认后端已部署浏览量汇总功能',
    'adminPanel.peerTrafficWarn': '对端站点流量拉取失败',
    'adminPanel.eastChinaHint': '华东识别需安装离线库 ip2region（免费）。总 PV 不受影响',
    'adminPanel.trafficSourceNote': '数据来源：本机 Nginx access log。中文版=国内站，英文版=国际站；华东按访问 IP 离线判断省市。',
    'adminPanel.businessTitle': '业务数据',
    'adminPanel.ordersTotal': '下单总数',
    'adminPanel.ordersPaid': '已支付',
    'adminPanel.feedbackTotal': '意见反馈',
    'adminPanel.feedbackOpen': '待处理意见',
    'adminPanel.businessNote': '近 7 天：下单 {orders7d}，意见 {feedback7d}',
    'adminPanel.domainDataTitle': '领域数据',
    // -- 用户管理 --
    'adminPanel.userManagement': '用户管理',
    'adminPanel.searchUsers': '搜索用户名/邮箱/手机号',
    'adminPanel.editUser': '编辑用户',
    'adminPanel.userDetail': '用户详情',
    'adminPanel.confirmDisable': '确定禁用该用户？',
    'adminPanel.confirmEnable': '确定启用该用户？',
    // -- 分类管理 --
    'adminPanel.categoryManagement': '分类管理',
    'adminPanel.createCategory': '新建分类',
    'adminPanel.editCategory': '编辑分类',
    // -- 评论管理 --
    'adminPanel.reviewManagement': '评论管理',
    'adminPanel.searchReviews': '搜索评论内容/工具名',
    'adminPanel.reviewDetail': '评论详情',
    'adminPanel.approve': '通过',
    'adminPanel.reject': '拒绝',
    'adminPanel.approved': '已通过',
    'adminPanel.pending': '待审核',
    // -- 工具管理 --
    'adminPanel.toolManagement': '工具管理',
    'adminPanel.createTool': '新建工具',
    'adminPanel.editTool': '编辑工具',
    // -- 数据统计 --
    'adminPanel.statsTitle': '数据统计',
    'adminPanel.systemOverview': '系统概览',
    'adminPanel.tierDistribution': '合规等级分布',
    'adminPanel.availDistribution': '可用性分布',
    'adminPanel.recent7d': '近7天趋势',
    'adminPanel.newTools7d': '新增工具 (7天)',
    'adminPanel.newUsers7d': '新增用户 (7天)',
    'adminPanel.newReviews7d': '新增评论 (7天)',
    // -- 通用列名 --
    'adminPanel.colUsername': '用户名',
    'adminPanel.colEmail': '邮箱',
    'adminPanel.colPhone': '手机号',
    'adminPanel.colAuthProvider': '认证方式',
    'adminPanel.colRole': '角色',
    'adminPanel.colStatus': '状态',
    'adminPanel.colLastLogin': '最后登录',
    'adminPanel.colCreatedAt': '创建时间',
    'adminPanel.colIcon': '图标',
    'adminPanel.colCatName': '分类名称',
    'adminPanel.colToolCount': '工具数量',
    'adminPanel.colSortOrder': '排序',
    'adminPanel.colDescription': '描述',
    'adminPanel.colTool': '工具',
    'adminPanel.colUser': '用户',
    'adminPanel.colRating': '评分',
    'adminPanel.colComment': '评论内容',
    'adminPanel.colApproved': '审核状态',
    'adminPanel.colTitle': '标题',
    'adminPanel.colLogo': 'Logo',
    'adminPanel.colCategory': '分类',
    'adminPanel.colViews': '浏览量',
    'adminPanel.colFeatured': '精选',
    'adminPanel.colShortDesc': '简介',
    'adminPanel.colWebsite': '官网',
    // -- 通用操作 --
    'adminPanel.active': '正常',
    'adminPanel.disabled': '已禁用',
    'adminPanel.confirmDelete': '确定删除？此操作不可撤销',
    'adminPanel.fetchFailed': '获取数据失败',
    'adminPanel.updateSuccess': '更新成功',
    'adminPanel.updateFailed': '更新失败',
    'adminPanel.createSuccess': '创建成功',
    'adminPanel.deleteSuccess': '删除成功',
    'adminPanel.deleteFailed': '删除失败',

    // ===== Admin =====
    'admin.title': '合规后台管理',
    'admin.totalTools': '工具总数',
    'admin.t1Count': 'T1 完全合规',
    'admin.t2Count': 'T2 部分合规',
    'admin.t3Count': 'T3 不合规',
    'admin.cnNative': '国产原生',
    'admin.directAccess': '直接可用',
    'admin.export': '导出',
    'admin.exportJson': '导出JSON',
    'admin.refresh': '刷新',
    'admin.batchUpdate': '批量更新',
    'admin.editCompliance': '编辑合规信息',
    'admin.save': '保存',
    'admin.batchConfirm': '确认批量更新 {count} 个工具？',
    'admin.searchPlaceholder': '搜索工具名称...',
    'admin.colName': '工具名称',
    'admin.colAvailability': '可用性',
    'admin.colTier': '合规等级',
    'admin.colScore': '合规评分',
    'admin.colInvoice': '发票',
    'admin.colContract': '合同',
    'admin.colOnPrem': '私有部署',
    'admin.colActions': '操作',
    'admin.edit': '编辑',
    'admin.fetchFailed': '获取工具列表失败',
    'admin.updateSuccess': '合规信息更新成功',
    'admin.updateFailed': '更新失败',
    'admin.exportSuccess': '导出成功',
    'admin.exportFailed': '导出失败',
    'admin.selectToolsFirst': '请先选择工具',
    'admin.setBatchValue': '请设置批量值',
    'admin.batchSuccess': '已批量更新 {count} 个工具',
    'admin.batchFailed': '批量更新失败',
    'admin.selectedCount': '已选 {count} 项',
    'admin.selectValue': '选择值',
    'admin.cancelSelection': '取消选择',
    'admin.totalItems': '共 {total} 项',
    'admin.complianceDimensions': '八维合规评分',
    'admin.autoCalcNote': '保存时将自动计算综合评分和合规等级',
    'admin.dimScore': '评分 (0-100)',
    'admin.dimStatus': '状态',
    'admin.dimEvidence': '依据',
    'admin.dimEvidencePlaceholder': '可选',
    'admin.editComplianceFor': '编辑合规信息 - {name}',
    'admin.cnUrlPlaceholder': 'https://...',
    'admin.cnIcpPlaceholder': '如：京ICP证...',
    'admin.sectionCnAvail': '中国可用性',
    'admin.sectionEnterprise': '企业采购',
    'admin.labelAvailability': '可用性',
    'admin.labelCnUrl': '国内URL',
    'admin.labelIcp': 'ICP备案',
    'admin.labelAppStore': '国内应用商店',
    'admin.labelWechat': '微信小程序',
    'admin.labelInvoice': '支持发票',
    'admin.labelContract': '支持签约',
    'admin.labelOnPrem': '私有化部署',
    'admin.labelChannel': '采购渠道',
    'admin.labelContact': '采购联系',
    'admin.labelContactPlaceholder': 'URL或邮箱',
    'admin.labelMinSeats': '最低席位数',
    'admin.channelDirect': '直接采购',
    'admin.channelReseller': '经销商',
    'admin.channelCloud': '云市场',
    'admin.channelOpensource': '开源',
    'admin.yes': '是',
    'admin.no': '否',
    'admin.cancel': '取消',

    // ===== 反馈 =====
    'feedback.title': '意见反馈',
    'feedback.correctionTitle': '工具纠错/反馈',
    'feedback.type': '反馈类型',
    'feedback.typeGeneral': '综合建议',
    'feedback.typeBug': '功能异常',
    'feedback.typeBusiness': '商务合作',
    'feedback.typeDataError': '数据错误',
    'feedback.typeToolCorrection': '工具纠错',
    'feedback.typeNewTool': '工具提交',
    'feedback.message': '反馈内容',
    'feedback.messagePlaceholder': '请详细描述您的反馈或问题（5-5000字）',
    'feedback.contact': '联系方式（选填）',
    'feedback.contactPlaceholder': '邮箱或微信号，方便我们联系您',
    'feedback.availabilitySuggestion': '建议修改为',
    'feedback.evidenceUrl': '佐证链接（选填）',
    'feedback.evidenceUrlPlaceholder': '提供截图或相关链接',
    'feedback.submit': '提交反馈',
    'feedback.submitSuccess': '反馈提交成功，感谢您的参与！',
    'feedback.submitSuccessDesc': '我们会尽快处理，如有留下联系方式，会及时回复您。',
    'feedback.submitFailed': '提交失败，请稍后重试',
    'feedback.backHome': '返回首页',
    'feedback.backTool': '返回工具页',
    'feedback.submitAnother': '继续反馈',
    'feedback.correctionButton': '纠错/反馈',
    'feedback.forTool': '针对工具：{name}',
    'feedback.subtitle': '您的每一条反馈都将帮助我们做得更好',
    'feedback.alertMessage': '我们重视每一条反馈，提交后将尽快处理。',
    'feedback.typeRequired': '请选择反馈类型',
    'feedback.messageRequired': '请输入反馈内容',
    'feedback.messageMin': '至少输入5个字符',
    'feedback.messageMax': '不超过5000个字符',
    'feedback.selectOptional': '请选择（可选）',
    'feedback.invalidUrl': '请输入有效URL',
    // Admin 反馈
    'feedback.adminTitle': '反馈管理',
    'feedback.statusNew': '待处理',
    'feedback.statusInReview': '处理中',
    'feedback.statusResolved': '已解决',
    'feedback.statusRejected': '已拒绝',
    'feedback.adminNote': '管理员备注',
    'feedback.adminLoadFailed': '加载反馈列表失败',
    'feedback.adminUpdateSuccess': '更新成功',
    'feedback.adminUpdateFailed': '更新失败',
    'feedback.colTime': '时间',
    'feedback.colStatus': '状态',
    'feedback.colTool': '关联工具',
    'feedback.colContact': '联系方式',
    'feedback.colActions': '操作',
    'feedback.viewDetail': '查看详情',
    'feedback.updateStatus': '处理',
    'feedback.filterStatus': '状态筛选',
    'feedback.filterType': '类型筛选',
    'feedback.searchKeyword': '搜索关键词',
    'feedback.totalItems': '共 {total} 条',
    'feedback.updateStatusTitle': '更新反馈状态',
    'feedback.messageLabel': '反馈内容：',
    'feedback.changeStatusTo': '修改状态为：',
    'feedback.optionalNote': '可选备注',
    'feedback.detailTitle': '反馈详情',
    'feedback.process': '处理',
    'feedback.typePrefix': '类型：',
    'feedback.statusPrefix': '状态：',
    'feedback.toolPrefix': '关联工具：',
    'feedback.suggestedAvailability': '建议可用性：',
    'feedback.evidencePrefix': '佐证链接：',
    'feedback.contactPrefix': '联系方式：',
    'feedback.sourcePagePrefix': '来源页面：',
    'feedback.submittedAt': '提交时间：',

    // ===== 订单管理 =====
    'orders.title': '订单管理',
    'orders.totalOrders': '总订单',
    'orders.totalRevenue': '总收入',
    'orders.pendingPayment': '待支付',
    'orders.activeBenefits': '生效权益',
    'orders.searchPlaceholder': '搜索订单号/工具名/联系人',
    'orders.paymentStatus': '支付状态',
    'orders.benefitStatus': '权益状态',
    'orders.plan': '套餐',
    'orders.refresh': '刷新',
    'orders.createOrder': '创建订单',
    'orders.orderNo': '订单号',
    'orders.toolName': '工具名称',
    'orders.toolUrl': '工具网址',
    'orders.amount': '金额',
    'orders.createdAt': '创建时间',
    'orders.actions': '操作',
    'orders.detail': '详情',
    'orders.confirmPay': '确认支付',
    'orders.grantBenefit': '授予权益',
    'orders.revokeBenefit': '撤销权益',
    'orders.total': '共',
    'orders.records': '条',
    'orders.orderDetail': '订单详情',
    'orders.paymentMethod': '支付方式',
    'orders.methodWechat': '微信支付',
    'orders.methodAlipay': '支付宝',
    'orders.methodOther': '其他',
    'orders.paidAt': '支付时间',
    'orders.contactInfo': '联系方式',
    'orders.user': '用户',
    'orders.benefitInfo': '权益信息',
    'orders.benefitActivatedAt': '生效时间',
    'orders.benefitExpiresAt': '到期时间',
    'orders.benefitNote': '权益备注',
    'orders.benefitDescription': '套餐权益说明',
    'orders.adminNote': '管理员备注',
    'orders.confirmPayTitle': '确认支付状态',
    'orders.manageBenefit': '管理权益',
    'orders.expiresDays': '有效期',
    'orders.expiresDaysHint': '选择权益有效天数',
    'orders.days': '天',
    'orders.benefitHint': '权益变更提示',
    'orders.benefitHintStd': '标准版（¥50）: 优先审核、标准展示徽章、30天有效',
    'orders.benefitHintPro': '高级版（¥698）: 首页曝光、精选推荐、专属徽章、SEO加权、365天有效',
    'orders.toolNameRequired': '请输入工具名称',
    'orders.planFree': '免费收录',
    'orders.planStd': '标准版',
    'orders.planPro': '高级版',
    'orders.statusPending': '待支付',
    'orders.statusPaid': '已支付',
    'orders.statusExpired': '已过期',
    'orders.statusRefunded': '已退款',
    'orders.benefitInactive': '未激活',
    'orders.benefitActive': '已激活',
    'orders.benefitExpired': '已过期',
    'orders.benefitRevoked': '已撤销',
    'orders.expiresAt': '到期日',
    'orders.paymentUpdated': '支付状态已更新',
    'orders.benefitUpdated': '权益已更新',
    'orders.updateFailed': '更新失败',
    'orders.createSuccess': '订单创建成功',
    'orders.createFailed': '订单创建失败',
    // 用户端
    'orders.myOrdersTitle': '我的订单与权益',
    'orders.myOrdersSubtitle': '查看您的工具提交订单和已获得的权益',
    'orders.activeBenefitsTitle': '我的活跃权益',
    'orders.pendingHint': '您有 {count} 笔订单待支付',
    'orders.goToPay': '去支付',
    'orders.allOrders': '全部订单',
    'orders.noOrders': '暂无订单，去提交您的AI工具吧！',
    'orders.submitTool': '提交工具',
    'orders.viewTool': '查看工具',
    'orders.expiringIn': '即将到期',
    'orders.remaining': '剩余',
    'orders.stepSubmitted': '已提交',
    'orders.stepPaid': '已支付',
    'orders.stepActivated': '已激活',
    'orders.benefitCompare': '套餐权益对比',
    'orders.benefitFree1': '基础收录展示',
    'orders.benefitFree2': '标准搜索可发现',
    'orders.benefitStd1': '优先人工审核',
    'orders.benefitStd2': '⭐ 标准收录徽章',
    'orders.benefitStd3': '分类页优先排序',
    'orders.benefitStd4': '30天有效期',
    'orders.benefitPro1': '🏆 首页精选展示',
    'orders.benefitPro2': '👑 高级认证徽章',
    'orders.benefitPro3': '搜索结果置顶',
    'orders.benefitPro4': 'SEO 优化加权',
    'orders.benefitPro5': '365天有效期',
    // 导航
    'nav.myOrders': '我的订单',

    // ===== 免责声明 =====
    'disclaimer.title': '免责声明',
    'disclaimer.section1Title': '一、信息来源',
    'disclaimer.section1Content': '本平台收录的 AI 工具信息均来自公开渠道，包括但不限于各工具官方网站、第三方数据聚合平台（如 TopAI.tools）。我们力求信息准确，但不对内容的完整性、准确性或时效性做任何保证。如您发现信息有误，欢迎通过纠错页面反馈。',
    'disclaimer.section2Title': '二、中国可用性说明',
    'disclaimer.section2Content': '本平台标注的"中国可用性"状态（如"可直连""访问受限""有镜像站"等）仅为参考信息，基于人工测试或社区反馈标注，可能因网络环境差异而发生变化。标注"访问受限"的工具表示该服务依赖境外网络链路，在部分网络环境下可能不可访问，请优先选择国内可用替代方案或使用企业合规跨境连接方案。本平台不提供、不推荐任何网络代理或翻墙服务。',
    'disclaimer.section3Title': '三、第三方链接',
    'disclaimer.section3Content': '本平台包含指向第三方网站的链接，仅为方便用户查阅。我们不对第三方网站的内容、隐私政策或安全性负责。访问第三方链接所产生的风险由用户自行承担。',
    'disclaimer.section4Title': '四、纠错与反馈',
    'disclaimer.section4Content': '如发现信息错误或有任何建议，欢迎通过以下方式联系我们：',
    'disclaimer.submitLink': '纠错/提交工具页面',
    'disclaimer.emailLink': '邮箱',
    'disclaimer.effectiveNote': '本声明自发布之日起生效，平台保留随时修改的权利。继续使用本平台即表示您同意本声明的全部内容。',

    // ===== 隐私政策 =====
    'privacy.title': '隐私政策',
    'privacy.section1Title': '一、信息收集',
    'privacy.section1Content': '我们在您使用本平台时可能收集以下信息：注册信息（用户名、邮箱地址）、搜索历史和浏览记录、收藏和评价内容、设备及浏览器基本信息（用于优化体验）。',
    'privacy.section2Title': '二、信息用途',
    'privacy.section2Content': '收集的信息仅用于：提供个性化推荐和搜索历史功能、改善平台服务质量、生成匿名统计数据。我们不会将您的个人信息出售或分享给第三方，除非法律要求。',
    'privacy.section3Title': '三、信息安全',
    'privacy.section3Content': '我们采取合理的技术和管理措施保护您的个人信息安全，包括：数据传输加密（HTTPS）、密码哈希存储、访问权限控制。但请注意，互联网传输不能保证100%安全。',
    'privacy.section4Title': '四、Cookie 使用',
    'privacy.section4Content': '本平台使用 Cookie 和本地存储来保存您的登录状态和语言偏好。您可以通过浏览器设置管理 Cookie。禁用 Cookie 可能影响部分功能的正常使用。',
    'privacy.section5Title': '五、联系方式',
    'privacy.section5Content': '如对隐私政策有任何疑问，请通过联系页面与我们联系。',
    'privacy.effectiveNote': '本政策自发布之日起生效，我们保留随时更新的权利。重大变更将在平台公告。',

    // ===== 提交/纠错 =====
    'submit.title': '提交 AI 工具',
    'submit.description': '将真实产品提交到 AI速览局：按任务展示、标注国内可用性，人工审核后上架。',
    'submit.success': '提交成功！我们会尽快审核您的工具，请留意通知。',
    'submit.failed': '提交失败，请稍后重试',
    'submit.typeLabel': '反馈类型',
    'submit.typeRequired': '请选择类型',
    'submit.typePlaceholder': '请选择',
    'submit.typeNew': '🆕 提交新工具',
    'submit.typeCorrection': '✏️ 信息纠错',
    'submit.typeAvailability': '🏷️ 可用性状态反馈',
    'submit.typeOther': '💬 其他反馈',
    'submit.toolNameLabel': '工具名称',
    'submit.toolNameRequired': '请填写工具名称',
    'submit.toolNamePlaceholder': '例如：ChatGPT',
    'submit.toolUrlLabel': '工具官网地址',
    'submit.toolUrlRequired': '请填写工具网址',
    'submit.descriptionLabel': '工具说明',
    'submit.descriptionRequired': '请填写工具说明',
    'submit.descriptionPlaceholder': '请简要介绍该 AI 工具的功能、特色和目标用户…',
    'submit.contactLabel': '联系方式',
    'submit.contactRequired': '请填写联系方式，方便我们与您沟通',
    'submit.contactPlaceholder': '邮箱 / 微信号 / 手机号',
    'submit.submitButton': '免费提交',
    'submit.submitAndPay': '提交并付款',
    'submit.planLabel': '选择方案',
    // -- Hero --
    'submit.heroTitle': '让全球用户发现你的 AI 工具',
    'submit.heroSubtitle': '提交真实产品到 AI速览局：按任务展示、标注国内可用性，人工审核后上架。当前开放免费提交。',
    'submit.heroBadge1': '✅ 免费收录可选',
    'submit.heroBadge2': '⚡ 人工审核',
    'submit.heroBadge3': '🇨🇳 可用性标注',
    'submit.heroCtaBtn': '立即提交',
    // -- Stats --
    'submit.stat1': '精选展示',
    'submit.stat2': '按任务分类',
    'submit.stat3': '国内可用性',
    'submit.stat4': '人工审核',
    'submit.stat1Value': '按任务',
    'submit.stat2Value': '可筛选',
    'submit.stat3Value': '有标注',
    'submit.stat4Value': '先审后上',
    // -- Pricing --
    'submit.pricingTitle': '选择适合你的方案',
    'submit.pricingSubtitle': '无论是独立开发者还是企业团队，都能找到适合的推广方案',
    'submit.popularTag': '最受欢迎',
    'submit.planFreeName': '免费收录',
    'submit.planFreePrice': '永久',
    'submit.planFreeBtn': '免费提交',
    'submit.planFreeF1': '基础工具列表展示',
    'submit.planFreeF2': '标准分类收录',
    'submit.planFreeF3': '社区用户可搜索',
    'submit.planFreeF4': '优先审核（3-5个工作日）',
    'submit.planFreeF5': '专属 Dofollow 外链',
    'submit.planFreeF6': '首页精选推荐展示',
    'submit.planFreeF7': '社交媒体推广',
    'submit.planStdName': '标准收录',
    'submit.planStdPrice': '次',
    'submit.planStdBtn': '立即购买',
    'submit.planStdF1': '精选工具列表展示',
    'submit.planStdF2': '所有分类优先排序',
    'submit.planStdF3': '24小时极速审核',
    'submit.planStdF4': '专属 Dofollow 外链',
    'submit.planStdF5': '「已认证」专业徽章',
    'submit.planStdF6': '首页 7 天精选推荐',
    'submit.planStdF7': '专属社交媒体推广',
    'submit.planProName': '首页曝光',
    'submit.planProPrice': '7天',
    'submit.planProBtn': '抢占黄金位',
    'submit.planProF1': '首页顶部精选展示 7 天',
    'submit.planProF2': '「热门推荐」标签置顶',
    'submit.planProF3': '1小时极速审核上线',
    'submit.planProF4': '高权重 Dofollow 外链',
    'submit.planProF5': '全站搜索结果置顶',
    'submit.planProF6': '专属社交媒体推广报告',
    'submit.planProF7': '1对1 专属客服支持',
    // -- Comparison --
    'submit.cmpTitle': '方案功能对比',
    'submit.cmpFeature': '功能项',
    'submit.cmpRow1': '基础列表收录',
    'submit.cmpRow2': '审核时效',
    'submit.cmpRow3': 'Dofollow 外链',
    'submit.cmpRow4': '认证徽章',
    'submit.cmpRow5': '首页精选推荐',
    'submit.cmpRow6': '社交媒体推广',
    'submit.cmpRow7': '搜索结果置顶',
    'submit.cmpRow8': '专属客服',
    'submit.cmpDays': '个工作日',
    'submit.cmpImmediate': '1小时内',
    // -- How It Works --
    'submit.howTitle': '提交流程',
    'submit.howSubtitle': '简单四步，让你的工具被全球用户发现',
    'submit.step1Title': '选择方案',
    'submit.step1Desc': '填写工具基本信息并免费提交',
    'submit.step2Title': '填写信息',
    'submit.step2Desc': '提供工具名称、网址、描述等基本信息',
    'submit.step3Title': '审核收录',
    'submit.step3Desc': '我们的团队将快速审核并收录你的工具',
    'submit.step4Title': '获得曝光',
    'submit.step4Desc': '工具上线后即可获得来自全球的访问流量',
    // -- Benefits --
    'submit.whyTitle': '为什么选择 AI速览局？',
    'submit.whySubtitle': '我们为 AI 工具开发者和企业提供最全面的推广解决方案',
    'submit.benefit1Title': '海量精准流量',
    'submit.benefit1Desc': '平台每月有数十万活跃用户精准搜索 AI 工具，直达目标受众',
    'submit.benefit2Title': '专业品牌背书',
    'submit.benefit2Desc': '被收录的工具获得评测评分与认证徽章，大幅提升品牌信任度',
    'submit.benefit3Title': 'SEO 自然流量',
    'submit.benefit3Desc': 'SEO 优化的专属详情页持续为你的产品带来免费搜索引擎流量',
    'submit.benefit4Title': '中国市场准入',
    'submit.benefit4Desc': '提供中国大陆可用性标注与合规认证，帮助工具快速进入中国市场',
    'submit.benefit5Title': '高质量外链',
    'submit.benefit5Desc': '付费方案提供 Dofollow 外链，有效提升你的网站 SEO 权重与排名',
    'submit.benefit6Title': '社群推广',
    'submit.benefit6Desc': '首页曝光方案包含全渠道社交媒体推广，触达更多潜在用户',
    // -- Trust --
    'submit.trustTitle': '值得信赖',
    'submit.trust1': '信息安全保障',
    'submit.trust2': '7×24 客服支持',
    'submit.trust3': '已服务 500+ 工具',
    'submit.trust4': '全球用户覆盖',
    // -- Payment --
    'submit.paymentNotice': '提交后将跳转至付款页面，付款完成后工具将进入优先审核通道。支持微信支付、支付宝。',
    // -- Form --
    'submit.formTitle': '提交你的工具',
    'submit.formSubtitle': '填写以下信息，开启全球推广之旅',
    'submit.categoryLabel': '工具类别',
    'submit.categoryPlaceholder': '选择类别（可选）',
    'submit.catWriting': '✍️ AI 写作',
    'submit.catImage': '🎨 AI 绘画/图像',
    'submit.catVideo': '🎬 AI 视频',
    'submit.catCode': '💻 AI 编程',
    'submit.catChat': '🤖 AI 聊天机器人',
    'submit.catProductivity': '📊 AI 效率工具',
    'submit.catOther': '📦 其他',
    // -- 扩展表单字段 --
    'submit.section.basic': '基本信息',
    'submit.section.description': '详细描述',
    'submit.section.pricing': '定价信息',
    'submit.section.cnAvailability': '中国可用性',
    'submit.section.enterprise': '企业采购信息',
    'submit.section.discount': '平台专属优惠',
    'submit.section.contact': '联系方式与标签',
    'submit.nameEnLabel': '英文名称',
    'submit.nameEnPlaceholder': '例如：ChatGPT',
    'submit.nameZhLabel': '中文名称',
    'submit.nameZhPlaceholder': '例如：智谱清言',
    'submit.shortDescLabel': '一句话简介',
    'submit.shortDescPlaceholder': '简短描述工具核心功能，不超过 100 字',
    'submit.shortDescRequired': '请填写一句话简介',
    'submit.descEnLabel': '英文描述',
    'submit.descEnPlaceholder': 'Tool description in English…',
    'submit.descZhLabel': '中文描述',
    'submit.descZhPlaceholder': '工具的中文详细描述…',
    'submit.logoLabel': 'Logo（1:1 正方形）',
    'submit.logoPlaceholder': 'https://example.com/logo.png',
    'submit.showcaseLabel': '展示图（16:9 宽屏）',
    'submit.showcasePlaceholder': 'https://example.com/screenshot.png',
    'submit.apiDocLabel': 'API 文档地址',
    'submit.apiDocPlaceholder': 'https://docs.example.com/api',
    'submit.pricingTypeLabel': '定价模式',
    'submit.pricingTypeFree': '免费',
    'submit.pricingTypeFreemium': '免费增值',
    'submit.pricingTypePaid': '付费',
    'submit.pricingTypeContact': '联系咨询',
    'submit.pricingDetailLabel': '定价详情',
    'submit.pricingDetailPlaceholder': '例如：免费基础版，Pro $20/月',
    'submit.cnUrlLabel': '中国区访问地址',
    'submit.cnUrlPlaceholder': 'https://cn.example.com',
    'submit.cnIcpLabel': 'ICP 备案号',
    'submit.cnIcpPlaceholder': '例如：京ICP备XXXXXXXX号',
    'submit.cnAppStoreLabel': '有国内应用商店版本',
    'submit.cnWechatMiniLabel': '有微信小程序',
    'submit.cnAltNamesLabel': '国区替代产品名称',
    'submit.cnAltNamesPlaceholder': '国内的替代品名称，逗号分隔',
    'submit.invoiceLabel': '支持开票',
    'submit.contractLabel': '支持签约',
    'submit.onPremLabel': '支持私有化部署',
    'submit.procurementChannelLabel': '采购渠道',
    'submit.procurementDirect': '直接采购',
    'submit.procurementReseller': '经销商',
    'submit.procurementMarketplace': '云市场',
    'submit.procurementOpensource': '开源',
    'submit.procurementContactLabel': '采购联系人',
    'submit.procurementContactPlaceholder': '采购联系邮箱或电话',
    'submit.minSeatsLabel': '最低起购席位',
    'submit.minSeatsPlaceholder': '例如：5',
    'submit.enterpriseFeaturesLabel': '企业特性',
    'submit.enterpriseFeaturesPlaceholder': '例如：SSO, 审计日志, 自定义域名（逗号分隔）',
    'submit.hasDiscountLabel': '是否为本平台用户提供专属优惠',
    'submit.discountDescLabel': '优惠描述',
    'submit.discountDescPlaceholder': '例如：新用户首年 8 折、免费加送50次调用',
    'submit.couponCodeLabel': '优惠码 / 折扣码',
    'submit.couponCodePlaceholder': '例如：GLOBALAI20',
    'submit.discountUrlLabel': '专属优惠链接',
    'submit.discountUrlPlaceholder': '带优惠的注册/购买链接，如 https://example.com/?ref=globalai',
    // -- FAQ --
    'submit.faqTitle': '常见问题',
    'submit.faq1Q': '现在如何收录工具？',
    'submit.faq1A': '当前仅开放免费收录：提交后进入人工审核队列，通过后会出现在工具目录与搜索中。付费加速/首页曝光暂未开放。',
    'submit.faq2Q': '提交后多久能上线？',
    'submit.faq2A': '免费方案通常在数个工作日内完成人工审核；具体以审核排队情况为准。',
    'submit.faq3Q': '现在收费吗？',
    'submit.faq3A': '当前仅开放免费提交与人工审核上架。付费推广与在线收款暂未开放，资质就绪后再开通。',
    'submit.faq4Q': '免费上架后工具会一直保留吗？',
    'submit.faq4A': '审核通过后工具会保留在目录中。付费首页曝光等权益恢复开通后再另行说明。',
    'submit.faq5Q': '可以提交自己开发的工具吗？',
    'submit.faq5A': '当然！我们欢迎开发者和企业提交自研的 AI 工具，这是获得早期用户和市场反馈的绝佳方式。',
    'submit.faq6Q': '付费后不满意可以退款吗？',
    'submit.faq6A': '如果工具未通过审核，我们将全额退款。如果已上线但效果不佳，首页曝光方案支持在首日内联系客服协商退款。',
    // -- Final CTA --
    'submit.ctaTitle': '准备好让你的 AI 工具被全球发现了吗？',
    'submit.ctaDesc': '提交真实产品，经人工审核后进入按任务选型的目录',
    'submit.ctaBtn': '立即提交工具',

    // ===== 支付页面 =====
    'payment.title': '选择支付方式',
    'payment.subtitle': '根据您选择的套餐，扫码完成支付',
    'payment.planFree': '免费版',
    'payment.planStandard': '标准版',
    'payment.planPremium': '旗舰版',
    'payment.selectMethod': '选择支付方式',
    'payment.scanTip': '请使用手机扫描下方二维码完成支付',
    'payment.amountLabel': '应付金额',
    'payment.stepsTitle': '支付流程',
    'payment.step1Title': '扫码支付',
    'payment.step1Desc': '使用支付宝或微信扫描上方二维码，输入金额完成支付',
    'payment.step2Title': '保存凭证',
    'payment.step2Desc': '支付完成后截图保存支付凭证（交易单号或截图）',
    'payment.step3Title': '联系客服',
    'payment.step3Desc': '将支付凭证发送至客服邮箱 xinle@quanqiuai.com.sn',
    'payment.step4Title': '开通服务',
    'payment.step4Desc': '客服确认后 24 小时内为你开通对应权益',
    'payment.noticeTitle': '温馨提示',
    'payment.supportTitle': '需要帮助？',
    'payment.supportDesc': '支付遇到问题请联系客服：xinle@quanqiuai.com.sn',
    'payment.copyEmail': '复制邮箱',
    'payment.emailCopied': '邮箱已复制到剪贴板',
    'payment.guarantee1': '安全支付保障',
    'payment.guarantee2': '7×24 客服支持',
    'payment.guarantee3': '未通过审核全额退款',

    // ===== 定价页面 =====
    'pricing.title': '选择适合您的套餐',
    'pricing.subtitle': '为您的AI工具选择推广方案，获得更多曝光与流量',
    'pricing.perMonth': '/月',
    'pricing.perYear': '/年',
    'pricing.currentPlan': '当前方案',
    'pricing.choosePlan': '选择方案',
    'pricing.contactSales': '联系销售',
    'pricing.popular': '最受欢迎',
    'pricing.freeFeatures': '基础收录,标准展示,社区支持',
    'pricing.standardFeatures': '优先审核,热度加权30天,标准徽章,邮件支持',
    'pricing.premiumFeatures': '置顶展示30天,热度加权365天,旗舰徽章,推荐位,专属客服',
    'pricing.faq': '常见问题',
    'pricing.faq1q': '付费后多久生效？',
    'pricing.faq1a': '管理员确认支付后24小时内自动开通权益。',
    'pricing.faq2q': '现在支持付费套餐吗？',
    'pricing.faq2a': '暂不支持。当前仅开放免费上架，提交后由我们人工审核。付费套餐与收款将在相关资质就绪后恢复。',
    'pricing.faq3q': '不满意可以退款吗？',
    'pricing.faq3a': '未通过审核的工具可全额退款，已开通权益的按剩余天数比例退款。',

    // ===== 结算页面 =====
    'checkout.title': '订单结算',
    'checkout.orderInfo': '订单信息',
    'checkout.plan': '套餐',
    'checkout.amount': '金额',
    'checkout.toolName': '工具名称',
    'checkout.toolNamePlaceholder': '请输入您的AI工具名称',
    'checkout.contact': '联系方式',
    'checkout.contactPlaceholder': '邮箱或手机号',
    'checkout.note': '备注',
    'checkout.notePlaceholder': '选填，如有特殊需求请注明',
    'checkout.createOrder': '创建订单',
    'checkout.payNow': '我已支付，提交凭证',
    'checkout.orderCreated': '订单已创建',
    'checkout.orderNo': '订单号',
    'checkout.expiresIn': '请在 {time} 内完成支付',
    'checkout.paymentRef': '支付凭证号',
    'checkout.paymentRefPlaceholder': '交易单号或转账截图备注',
    'checkout.submitted': '凭证已提交，等待管理员确认',
    'checkout.viewMyOrders': '查看我的订单',

    // ===== 联系我们 =====
    'contact.title': '联系我们',
    'contact.subtitle': '如有任何问题或建议，欢迎通过以下方式与我们联系。',
    'contact.emailTitle': '电子邮件',
    'contact.emailDesc': '工作日 24 小时内回复',
    'contact.feedbackTitle': '纠错与反馈',
    'contact.feedbackDesc': '发现信息错误或想推荐工具',
    'contact.feedbackLink': '前往反馈页面 →',
    'contact.githubDesc': '开源项目地址',
  },
  'en-US': {
    // ===== Common =====
    'common.search': 'Search',
    'common.back': 'Back',
    'common.cancel': 'Cancel',
    'common.confirm': 'Confirm',
    'common.close': 'Close',
    'common.refresh': 'Refresh',
    'common.loading': 'Loading...',
    'common.unknown': 'Unknown',
    'common.pleaseLogin': 'Please log in first',
    'common.operationFailed': 'Operation failed',
    'common.submitFailed': 'Submit failed',
    'common.yes': 'Yes',
    'common.no': 'No',

    // ===== Navigation =====
    'nav.home': 'Home',
    'nav.tools': 'AI Tools',
    'nav.profile': 'Profile',
    'nav.logout': 'Logout',
    'nav.login': 'Login',
    'nav.register': 'Sign Up',
    'nav.deals': 'Deals',
    'nav.submit': 'Submit',
    'nav.admin': 'Admin',

    // ===== Footer =====
    'footer.desc': 'Pick AI tools by job, with mainland China access notes',
    'footer.contact': 'Contact',
    'footer.privacy': 'Privacy',
    'footer.terms': 'Terms',
    'footer.disclaimer': 'Disclaimer',
    'footer.submit': 'Submit / Correct',
    'footer.feedback': 'Feedback',
    'footer.legalNotice': 'Operated in compliance with applicable laws and regulations',

    // ===== Home =====
    'home.heroTitle': 'Pick AI tools by job',
    'home.heroSub': 'Start from the task, then check mainland China access. Skip lookalike domains and stale prices.',
    'home.heroSubWithCats': 'Buying notes + China-access labels · {catCount} categories',
    'home.searchPlaceholder': 'Search a job or tool… e.g. image, coding, meeting notes',
    'home.featured': 'Featured',
    'home.jobsTitle': 'Start from a job',
    'home.recommend': 'Recommended For You',
    'home.byCategory': 'Browse by Category',
    'home.allCategories': 'All Categories',
    'home.viewAll': 'View All',
    'home.toolCount': '{count} tools',
    'home.browseAllCategories': 'Browse All Categories',
    'home.browseAll': 'Explore All Tools',

    // ===== Pricing =====
    'pricing.free': 'Free',
    'pricing.freemium': 'Freemium',
    'pricing.paid': 'Paid',
    'pricing.contact': 'Contact',

    // ===== Tools List =====
    'tools.filter': 'Filter',
    'tools.clearFilter': 'Clear',
    'tools.clearAll': 'Clear All',
    'tools.resetFilter': 'Reset',
    'tools.category': 'Category',
    'tools.searchCategory': 'Search category...',
    'tools.pricing': 'Pricing',
    'tools.pricingAll': 'All',
    'tools.searchPlaceholder': 'Search AI tools...',
    'tools.searchFullPlaceholder': 'Search AI tool names, descriptions, tags...',
    'tools.totalFound': '{count} in this list',
    'tools.narrowHint': 'Filter first, or start from a job on Home',
    'tools.noResult': 'No matching tools found',
    'tools.noResultSearch': 'No tools found matching "{keyword}"',
    'tools.noResultGeneric': 'No tools match the current filters',
    'tools.recentSearch': 'Recent Searches',
    'tools.clearHistory': 'Clear History',
    'tools.noRating': 'No rating',
    // Sort
    'tools.sortHotScore': '🔥 Trending',
    'tools.sortFunding': '💰 Funding',
    'tools.sortViewCount': '👁 Most Viewed',
    'tools.sortRating': '⭐ Top Rated',
    'tools.sortNewest': 'Newest',
    'tools.sortReviewCount': 'Most Reviewed',
    'tools.sortName': 'Name A-Z',
    'tools.sortCompliance': 'Compliance Score',

    // ===== Tool Detail =====
    'detail.visitSite': 'Visit Website',
    'detail.favorite': 'Favorite',
    'detail.favorited': 'Favorited',
    'detail.unfavorited': 'Unfavorited',
    'detail.favoriteSuccess': 'Favorited',
    'detail.description': 'Description',
    'detail.reviews': 'User Reviews',
    'detail.submitReview': 'Submit Review',
    'detail.updateReview': 'Update Review',
    'detail.cancelEdit': 'Cancel Edit',
    'detail.featured': 'Featured',
    'detail.uncategorized': 'Uncategorized',
    'detail.noRating': 'No rating',
    'detail.notFound': 'Tool not found or removed',
    'detail.toolNotExist': 'Tool not found',
    'detail.reviewUpdated': 'Review updated',
    'detail.reviewSubmitted': 'Review submitted',
    'detail.noScreenshot': 'No screenshot available',
    'detail.sourceEntry': 'Source Entry',
    'detail.reviewCount': '{count} reviews',
    'detail.viewCount': '{count} views',
    'detail.ratingLabel': 'Rating',
    'detail.ratingRequired': 'Please select a rating',
    'detail.reviewTitleLabel': 'Title',
    'detail.reviewTitleRequired': 'Please enter a review title',
    'detail.reviewTitlePlaceholder': 'Summarize your experience in one sentence',
    'detail.reviewContentLabel': 'Review',
    'detail.reviewContentRequired': 'Please enter your review',
    'detail.reviewContentMin': 'Review must be at least 10 characters',
    'detail.reviewContentPlaceholder': 'Share your experience...',
    'detail.loginToReview': ' to submit a review',
    'detail.anonymousUser': 'Anonymous',
    'detail.editReview': 'Edit Review',
    'detail.noReviews': 'No reviews yet. Be the first to review!',
    'detail.productInfo': 'Product Info',
    'detail.categoryLabel': 'Category: ',
    'detail.sourceLabel': 'Source: ',
    'detail.pricingLabel': 'Pricing: ',
    'detail.pricingDetail': 'Pricing Detail: ',
    'detail.ratingInfoLabel': 'Rating: ',
    'detail.reviewCountLabel': 'Reviews: ',
    'detail.reviewCountSuffix': '',
    'detail.viewCountLabel': 'Views: ',
    'detail.viewCountSuffix': '',
    'detail.updatedAt': 'Updated',
    'detail.supportsInvoice': 'Supports Invoicing',
    'detail.supportsContract': 'Supports Enterprise Contract',
    'detail.supportsOnPrem': 'Supports On-Premise Deployment',
    'detail.channelReseller': 'Reseller',
    'detail.channelMarketplace': 'Cloud Marketplace',
    'detail.channelOpenSource': 'Open Source',
    'detail.channelDirect': 'Direct',
    'detail.devResources': 'Developer Resources',
    'detail.apiDoc': 'API Documentation',
    'detail.correctFeedback': 'Correct / Feedback',
    'detail.complianceScoreTitle': 'Enterprise Compliance Score',
    'detail.visitWebsite': 'Visit Website',
    'detail.showcaseAlt': '{name} Showcase',
    'detail.complianceTooltip': 'Compliance {tier}',
    'detail.sectionKeyFeatures': 'Key Features',
    'detail.sectionPricing': 'Pricing',
    'detail.sectionUseCases': 'Use Cases',
    'detail.sectionTargetUsers': 'Target Users',
    // Source
    'source.topai': 'TopAI',
    'source.aicpb': 'AI Tools Collection',
    'source.manual': 'Manual Entry',
    'source.custom': 'Custom Source',

    // ===== Compliance =====
    'tools.availabilityCN': 'China Availability',
    'tools.complianceTier': 'Compliance Tier',
    'tools.enterprise': 'Enterprise',
    'tools.supportsInvoice': 'Invoice',
    'tools.supportsContract': 'Contract',
    'tools.supportsOnPrem': 'On-Premise',
    'tools.sortComplianceScore': 'Compliance Score',
    'availability.direct': 'Direct Access',
    'availability.vpn': 'Access Restricted',
    'availability.mirror': 'Mirror Available',
    'availability.blocked': 'Unavailable',
    'availability.cn_native': 'CN Native',
    'availability.unknown': 'Unknown',
    'tier.T1_full': 'T1 Fully Compliant',
    'tier.T2_partial': 'T2 Partially Compliant',
    'tier.T3_none': 'T3 Non-Compliant',
    'tier.pending': 'Pending',
    'status.passed': 'Passed',
    'status.failed': 'Failed',
    'status.in_progress': 'In Progress',
    'status.not_started': 'Not Started',
    'detail.chinaAvailability': 'China Availability',
    'detail.complianceRadar': 'Compliance Radar',
    'detail.overallScore': 'Overall Score',
    'detail.enterpriseProcurement': 'Enterprise Procurement',
    'detail.cnUrl': 'China URL',
    'detail.cnIcp': 'ICP Filing',
    'detail.cnAppStore': 'CN App Store',
    'detail.cnAppStoreAvailable': 'Available on CN App Store',
    'detail.cnWechat': 'WeChat Mini Program',
    'detail.cnWechatAvailable': 'WeChat Mini Program Available',
    'detail.procurementChannel': 'Channel',
    'detail.procurementContact': 'Contact',
    'detail.minSeats': 'Min Seats',
    'detail.enterpriseFeatures': 'Enterprise Features',
    'dim.data_residency': 'Data Residency',
    'dim.privacy': 'Privacy',
    'dim.encryption': 'Encryption',
    'dim.certification': 'Certification',
    'dim.content_moderation': 'Content Moderation',
    'dim.audit_logging': 'Audit Logging',
    'dim.sla_support': 'SLA & Support',
    'dim.export_control': 'Export Control',

    // ===== Auth =====
    'auth.welcomeBack': 'Welcome Back',
    'auth.loginDesc': 'Sign in to your GlobalAI Tools account',
    'auth.createAccount': 'Create Account',
    'auth.registerDesc': 'Join the GlobalAI Tools community',
    'auth.loginSuccess': 'Login successful',
    'auth.loginFailed': 'Login failed. Please check your email and password',
    'auth.registerSuccess': 'Registered and logged in successfully',
    'auth.registerFailed': 'Registration failed. Please try again',
    'auth.loggedOut': 'Logged out',
    'auth.emailLabel': 'Email',
    'auth.emailRequired': 'Please enter your email',
    'auth.emailInvalid': 'Please enter a valid email',
    'auth.passwordLabel': 'Password',
    'auth.passwordRequired': 'Please enter your password',
    'auth.passwordMin': 'Password must be at least 6 characters',
    'auth.passwordPlaceholder': 'Enter your password',
    'auth.usernameLabel': 'Username',
    'auth.usernameRequired': 'Please enter a username',
    'auth.usernameLength': 'Username must be 2-30 characters',
    'auth.usernamePattern': 'Letters, numbers, and underscores only',
    'auth.usernamePlaceholder': 'Your username',
    'auth.passwordPlaceholderNew': 'At least 6 characters',
    'auth.confirmPasswordLabel': 'Confirm Password',
    'auth.confirmPasswordRequired': 'Please confirm your password',
    'auth.passwordMismatch': 'Passwords do not match',
    'auth.confirmPasswordPlaceholder': 'Enter password again',
    'auth.noAccount': "Don't have an account?",
    'auth.goRegister': 'Sign Up',
    'auth.hasAccount': 'Already have an account?',
    'auth.goLogin': 'Log In',
    'auth.testAccount': 'Test accounts:',
    'auth.testAdmin': 'Admin:',
    'auth.testUser': 'User:',
    // -- Phone SMS Login --
    'auth.phoneLogin': 'Phone',
    'auth.emailLogin': 'Email',
    'auth.phoneLabel': 'Phone Number',
    'auth.phoneRequired': 'Please enter your phone number',
    'auth.phoneInvalid': 'Please enter a valid phone number',
    'auth.phonePlaceholder': 'Your phone number',
    'auth.codeLabel': 'Verification Code',
    'auth.codeRequired': 'Please enter the code',
    'auth.codeLength': 'Code must be 6 digits',
    'auth.codePlaceholder': '6-digit code',
    'auth.sendCode': 'Send Code',
    'auth.codeSent': 'Code sent successfully',
    'auth.codeSendFailed': 'Failed to send code',
    // -- Google Login --
    'auth.googleLogin': 'Sign in with Google',
    'auth.googleLoginFailed': 'Google login failed',
    'auth.googleNotConfigured': 'Not configured',
    'auth.orLoginWith': 'or',
    'auth.loggingIn': 'Signing in...',
    'auth.autoRegisterHint': 'Sign in with your Google account. A new account will be created automatically if needed.',

    // ===== Profile =====
    'profile.myFavorites': 'My Favorites',
    'profile.noFavorites': 'No favorites yet',
    'profile.discoverTools': 'Discover Tools',
    'profile.myReviews': 'My Reviews',
    'profile.unknownTool': 'Unknown Tool',
    'profile.noReviews': 'No reviews yet',
    'profile.exploreTools': 'Explore Tools',
    'profile.settings': 'Account Settings',
    'profile.saveChanges': 'Save Changes',
    'profile.editProfile': 'Edit Profile',
    'profile.updateSuccess': 'Profile updated',
    'profile.updateFailed': 'Update failed',
    'profile.roleAdmin': 'Admin',
    'profile.roleUser': 'User',
    'profile.registeredAt': 'Registered',

    // ===== Deals =====
    'deals.title': 'AI Tool Deals',
    'deals.subtitle': 'The best discounts, promotions and coupon codes for AI tools',
    'deals.searchPlaceholder': 'Search deals...',
    'deals.sortPopular': 'Most Popular',
    'deals.sortDiscount': 'Biggest Discount',
    'deals.sortNewest': 'Newest',
    'deals.sortExpiring': 'Expiring Soon',
    'deals.verifiedOnly': 'Verified Only',
    'deals.verified': 'Verified',
    'deals.totalFound': '{count} deals found',
    'deals.noResult': 'No deals available',
    'deals.getDeal': 'Get Deal',
    'deals.copyCoupon': 'Copy coupon code',
    'deals.couponCopied': 'Coupon code copied',
    'deals.expiringToday': 'Expires today',
    'deals.expiringDays': '{days} days left',
    'deals.upvoteFailed': 'Upvote failed',

    // ===== Admin Panel =====
    // -- Sidebar & Layout --
    'adminPanel.title': 'Admin Panel',
    'adminPanel.dashboard': 'Dashboard',
    'adminPanel.users': 'Users',
    'adminPanel.toolManage': 'Tool Management',
    'adminPanel.categories': 'Categories',
    'adminPanel.reviews': 'Reviews',
    'adminPanel.feedback': 'Feedback',
    'adminPanel.submissions': 'Submissions',
    'adminPanel.orders': 'Orders',
    'adminPanel.compliance': 'Compliance',
    'adminPanel.stats': 'Statistics',
    'adminPanel.backToSite': 'Back to Site',
    // -- Dashboard --
    'adminPanel.dashboardTitle': 'Dashboard Overview',
    'adminPanel.totalTools': 'Total Tools',
    'adminPanel.activeTools': 'Active Tools',
    'adminPanel.featuredTools': 'Featured Tools',
    'adminPanel.totalUsers': 'Total Users',
    'adminPanel.totalReviews': 'Total Reviews',
    'adminPanel.totalFavorites': 'Total Favorites',
    'adminPanel.quickActions': 'Quick Actions',
    'adminPanel.exportTools': 'Export Tools',
    'adminPanel.exportUsers': 'Export Users',
    'adminPanel.exportReviews': 'Export Reviews',
    'adminPanel.exportCSV': 'Export CSV',
    'adminPanel.opsSubtitle': 'Ops board: site management · traffic · business · domain data',
    'adminPanel.siteManageTitle': 'Site management',
    'adminPanel.siteManageNote': 'Edit tools, categories and assets via admin UI or Content API.',
    'adminPanel.contentApiDocs': 'Content API docs',
    'adminPanel.assets': 'Assets',
    'adminPanel.trafficTitle': 'Traffic (server logs)',
    'adminPanel.refreshTraffic': 'Re-aggregate logs',
    'adminPanel.zhPvToday': 'CN site PV today',
    'adminPanel.enPvToday': 'EN site PV today',
    'adminPanel.eastPvToday': 'East China PV today',
    'adminPanel.statDate': 'Date',
    'adminPanel.zhPv': 'Chinese',
    'adminPanel.enPv': 'English',
    'adminPanel.eastPv': 'East China',
    'adminPanel.trafficEmpty': 'No aggregated log data yet',
    'adminPanel.trafficUnavailable': 'Traffic API unavailable — deploy the traffic aggregator first',
    'adminPanel.peerTrafficWarn': 'Peer site traffic fetch failed',
    'adminPanel.eastChinaHint': 'East China needs free offline ip2region. Total PV still works.',
    'adminPanel.trafficSourceNote': 'Source: local Nginx access logs. ZH=CN site, EN=global site; East China via offline IP geo.',
    'adminPanel.businessTitle': 'Business',
    'adminPanel.ordersTotal': 'Orders',
    'adminPanel.ordersPaid': 'Paid',
    'adminPanel.feedbackTotal': 'Feedback',
    'adminPanel.feedbackOpen': 'Open feedback',
    'adminPanel.businessNote': 'Last 7 days: orders {orders7d}, feedback {feedback7d}',
    'adminPanel.domainDataTitle': 'Domain data',
    // -- User Management --
    'adminPanel.userManagement': 'User Management',
    'adminPanel.searchUsers': 'Search username / email / phone',
    'adminPanel.editUser': 'Edit User',
    'adminPanel.userDetail': 'User Details',
    'adminPanel.confirmDisable': 'Disable this user?',
    'adminPanel.confirmEnable': 'Enable this user?',
    // -- Category Management --
    'adminPanel.categoryManagement': 'Category Management',
    'adminPanel.createCategory': 'New Category',
    'adminPanel.editCategory': 'Edit Category',
    // -- Review Management --
    'adminPanel.reviewManagement': 'Review Management',
    'adminPanel.searchReviews': 'Search review content / tool name',
    'adminPanel.reviewDetail': 'Review Details',
    'adminPanel.approve': 'Approve',
    'adminPanel.reject': 'Reject',
    'adminPanel.approved': 'Approved',
    'adminPanel.pending': 'Pending',
    // -- Tool Management --
    'adminPanel.toolManagement': 'Tool Management',
    'adminPanel.createTool': 'New Tool',
    'adminPanel.editTool': 'Edit Tool',
    // -- Statistics --
    'adminPanel.statsTitle': 'Statistics',
    'adminPanel.systemOverview': 'System Overview',
    'adminPanel.tierDistribution': 'Compliance Tier Distribution',
    'adminPanel.availDistribution': 'Availability Distribution',
    'adminPanel.recent7d': 'Last 7 Days',
    'adminPanel.newTools7d': 'New Tools (7d)',
    'adminPanel.newUsers7d': 'New Users (7d)',
    'adminPanel.newReviews7d': 'New Reviews (7d)',
    // -- Column Labels --
    'adminPanel.colUsername': 'Username',
    'adminPanel.colEmail': 'Email',
    'adminPanel.colPhone': 'Phone',
    'adminPanel.colAuthProvider': 'Auth Provider',
    'adminPanel.colRole': 'Role',
    'adminPanel.colStatus': 'Status',
    'adminPanel.colLastLogin': 'Last Login',
    'adminPanel.colCreatedAt': 'Created At',
    'adminPanel.colIcon': 'Icon',
    'adminPanel.colCatName': 'Category Name',
    'adminPanel.colToolCount': 'Tool Count',
    'adminPanel.colSortOrder': 'Sort Order',
    'adminPanel.colDescription': 'Description',
    'adminPanel.colTool': 'Tool',
    'adminPanel.colUser': 'User',
    'adminPanel.colRating': 'Rating',
    'adminPanel.colComment': 'Comment',
    'adminPanel.colApproved': 'Approval',
    'adminPanel.colTitle': 'Title',
    'adminPanel.colLogo': 'Logo',
    'adminPanel.colCategory': 'Category',
    'adminPanel.colViews': 'Views',
    'adminPanel.colFeatured': 'Featured',
    'adminPanel.colShortDesc': 'Short Description',
    'adminPanel.colWebsite': 'Website',
    // -- Common Actions --
    'adminPanel.active': 'Active',
    'adminPanel.disabled': 'Disabled',
    'adminPanel.confirmDelete': 'Confirm delete? This cannot be undone.',
    'adminPanel.fetchFailed': 'Failed to fetch data',
    'adminPanel.updateSuccess': 'Updated successfully',
    'adminPanel.updateFailed': 'Update failed',
    'adminPanel.createSuccess': 'Created successfully',
    'adminPanel.deleteSuccess': 'Deleted successfully',
    'adminPanel.deleteFailed': 'Delete failed',

    // ===== Admin =====
    'admin.title': 'Compliance Admin',
    'admin.totalTools': 'Total Tools',
    'admin.t1Count': 'T1 Fully Compliant',
    'admin.t2Count': 'T2 Partially',
    'admin.t3Count': 'T3 Non-Compliant',
    'admin.cnNative': 'CN Native',
    'admin.directAccess': 'Direct Access',
    'admin.export': 'Export',
    'admin.exportJson': 'Export JSON',
    'admin.refresh': 'Refresh',
    'admin.batchUpdate': 'Batch Update',
    'admin.editCompliance': 'Edit Compliance',
    'admin.save': 'Save',
    'admin.batchConfirm': 'Confirm batch update for {count} tools?',
    'admin.searchPlaceholder': 'Search tool name...',
    'admin.colName': 'Tool Name',
    'admin.colAvailability': 'Availability',
    'admin.colTier': 'Compliance Tier',
    'admin.colScore': 'Compliance Score',
    'admin.colInvoice': 'Invoice',
    'admin.colContract': 'Contract',
    'admin.colOnPrem': 'On-Premise',
    'admin.colActions': 'Actions',
    'admin.edit': 'Edit',
    'admin.fetchFailed': 'Failed to fetch tools',
    'admin.updateSuccess': 'Compliance updated',
    'admin.updateFailed': 'Update failed',
    'admin.exportSuccess': 'Export successful',
    'admin.exportFailed': 'Export failed',
    'admin.selectToolsFirst': 'Please select tools first',
    'admin.setBatchValue': 'Please set batch value',
    'admin.batchSuccess': '{count} tools updated',
    'admin.batchFailed': 'Batch update failed',
    'admin.selectedCount': '{count} selected',
    'admin.selectValue': 'Select value',
    'admin.cancelSelection': 'Deselect',
    'admin.totalItems': 'Total {total}',
    'admin.complianceDimensions': 'Compliance Dimensions',
    'admin.autoCalcNote': 'Overall score and tier will be calculated automatically on save',
    'admin.dimScore': 'Score (0-100)',
    'admin.dimStatus': 'Status',
    'admin.dimEvidence': 'Evidence',
    'admin.dimEvidencePlaceholder': 'Optional',
    'admin.editComplianceFor': 'Edit Compliance - {name}',
    'admin.cnUrlPlaceholder': 'https://...',
    'admin.cnIcpPlaceholder': 'e.g. ICP Filing No.',
    'admin.sectionCnAvail': 'China Availability',
    'admin.sectionEnterprise': 'Enterprise Procurement',
    'admin.labelAvailability': 'Availability',
    'admin.labelCnUrl': 'CN URL',
    'admin.labelIcp': 'ICP Filing',
    'admin.labelAppStore': 'CN App Store',
    'admin.labelWechat': 'WeChat Mini Program',
    'admin.labelInvoice': 'Supports Invoice',
    'admin.labelContract': 'Supports Contract',
    'admin.labelOnPrem': 'On-Premise',
    'admin.labelChannel': 'Procurement Channel',
    'admin.labelContact': 'Procurement Contact',
    'admin.labelContactPlaceholder': 'URL or email',
    'admin.labelMinSeats': 'Min Seats',
    'admin.channelDirect': 'Direct',
    'admin.channelReseller': 'Reseller',
    'admin.channelCloud': 'Cloud Marketplace',
    'admin.channelOpensource': 'Open Source',
    'admin.yes': 'Yes',
    'admin.no': 'No',
    'admin.cancel': 'Cancel',

    // ===== Feedback =====
    'feedback.title': 'Feedback',
    'feedback.correctionTitle': 'Tool Correction / Feedback',
    'feedback.type': 'Feedback Type',
    'feedback.typeGeneral': 'General Suggestion',
    'feedback.typeBug': 'Bug Report',
    'feedback.typeBusiness': 'Business Inquiry',
    'feedback.typeDataError': 'Data Error',
    'feedback.typeToolCorrection': 'Tool Correction',
    'feedback.typeNewTool': 'New Tool Submission',
    'feedback.message': 'Message',
    'feedback.messagePlaceholder': 'Please describe your feedback in detail (5-5000 chars)',
    'feedback.contact': 'Contact (optional)',
    'feedback.contactPlaceholder': 'Email or WeChat for follow-up',
    'feedback.availabilitySuggestion': 'Suggest change to',
    'feedback.evidenceUrl': 'Evidence URL (optional)',
    'feedback.evidenceUrlPlaceholder': 'Provide a screenshot or relevant link',
    'feedback.submit': 'Submit Feedback',
    'feedback.submitSuccess': 'Feedback submitted successfully. Thank you!',
    'feedback.submitSuccessDesc': 'We will process your feedback soon. If you left contact info, we will reply promptly.',
    'feedback.submitFailed': 'Submit failed. Please try again later',
    'feedback.backHome': 'Back to Home',
    'feedback.backTool': 'Back to Tool',
    'feedback.submitAnother': 'Submit Another',
    'feedback.correctionButton': 'Correct / Feedback',
    'feedback.forTool': 'For tool: {name}',
    'feedback.subtitle': 'Every piece of feedback helps us improve',
    'feedback.alertMessage': 'We value every submission and will process it promptly.',
    'feedback.typeRequired': 'Please select a type',
    'feedback.messageRequired': 'Please enter a message',
    'feedback.messageMin': 'At least 5 characters',
    'feedback.messageMax': 'No more than 5000 characters',
    'feedback.selectOptional': 'Select (optional)',
    'feedback.invalidUrl': 'Please enter a valid URL',
    // Admin Feedback
    'feedback.adminTitle': 'Feedback Management',
    'feedback.statusNew': 'New',
    'feedback.statusInReview': 'In Review',
    'feedback.statusResolved': 'Resolved',
    'feedback.statusRejected': 'Rejected',
    'feedback.adminNote': 'Admin Note',
    'feedback.adminLoadFailed': 'Failed to load feedback list',
    'feedback.adminUpdateSuccess': 'Updated successfully',
    'feedback.adminUpdateFailed': 'Update failed',
    'feedback.colTime': 'Time',
    'feedback.colStatus': 'Status',
    'feedback.colTool': 'Tool',
    'feedback.colContact': 'Contact',
    'feedback.colActions': 'Actions',
    'feedback.viewDetail': 'View Detail',
    'feedback.updateStatus': 'Update Status',
    'feedback.filterStatus': 'Filter Status',
    'feedback.filterType': 'Filter Type',
    'feedback.searchKeyword': 'Search keyword',
    'feedback.totalItems': 'Total {total}',
    'feedback.updateStatusTitle': 'Update Feedback Status',
    'feedback.messageLabel': 'Message: ',
    'feedback.changeStatusTo': 'Change status to: ',
    'feedback.optionalNote': 'Optional note',
    'feedback.detailTitle': 'Feedback Detail',
    'feedback.process': 'Process',
    'feedback.typePrefix': 'Type: ',
    'feedback.statusPrefix': 'Status: ',
    'feedback.toolPrefix': 'Tool: ',
    'feedback.suggestedAvailability': 'Suggested Availability: ',
    'feedback.evidencePrefix': 'Evidence: ',
    'feedback.contactPrefix': 'Contact: ',
    'feedback.sourcePagePrefix': 'Source page: ',
    'feedback.submittedAt': 'Submitted: ',

    // ===== Orders =====
    'orders.title': 'Order Management',
    'orders.totalOrders': 'Total Orders',
    'orders.totalRevenue': 'Total Revenue',
    'orders.pendingPayment': 'Pending Payment',
    'orders.activeBenefits': 'Active Benefits',
    'orders.searchPlaceholder': 'Search order no / tool / contact',
    'orders.paymentStatus': 'Payment Status',
    'orders.benefitStatus': 'Benefit Status',
    'orders.plan': 'Plan',
    'orders.refresh': 'Refresh',
    'orders.createOrder': 'Create Order',
    'orders.orderNo': 'Order No.',
    'orders.toolName': 'Tool Name',
    'orders.toolUrl': 'Tool URL',
    'orders.amount': 'Amount',
    'orders.createdAt': 'Created',
    'orders.actions': 'Actions',
    'orders.detail': 'Detail',
    'orders.confirmPay': 'Confirm Paid',
    'orders.grantBenefit': 'Grant Benefit',
    'orders.revokeBenefit': 'Revoke',
    'orders.total': 'Total',
    'orders.records': 'records',
    'orders.orderDetail': 'Order Detail',
    'orders.paymentMethod': 'Payment Method',
    'orders.methodWechat': 'WeChat Pay',
    'orders.methodAlipay': 'Alipay',
    'orders.methodOther': 'Other',
    'orders.paidAt': 'Paid At',
    'orders.contactInfo': 'Contact',
    'orders.user': 'User',
    'orders.benefitInfo': 'Benefit Info',
    'orders.benefitActivatedAt': 'Activated At',
    'orders.benefitExpiresAt': 'Expires At',
    'orders.benefitNote': 'Benefit Note',
    'orders.benefitDescription': 'Plan Benefits',
    'orders.adminNote': 'Admin Note',
    'orders.confirmPayTitle': 'Confirm Payment Status',
    'orders.manageBenefit': 'Manage Benefit',
    'orders.expiresDays': 'Duration',
    'orders.expiresDaysHint': 'Select benefit duration',
    'orders.days': 'days',
    'orders.benefitHint': 'Benefit change notice',
    'orders.benefitHintStd': 'Standard ($7): Priority review, standard badge, 30-day validity',
    'orders.benefitHintPro': 'Premium ($99): Homepage feature, premium badge, SEO boost, 365-day validity',
    'orders.toolNameRequired': 'Tool name is required',
    'orders.planFree': 'Free Listing',
    'orders.planStd': 'Standard',
    'orders.planPro': 'Premium',
    'orders.statusPending': 'Pending',
    'orders.statusPaid': 'Paid',
    'orders.statusExpired': 'Expired',
    'orders.statusRefunded': 'Refunded',
    'orders.benefitInactive': 'Inactive',
    'orders.benefitActive': 'Active',
    'orders.benefitExpired': 'Expired',
    'orders.benefitRevoked': 'Revoked',
    'orders.expiresAt': 'Expires',
    'orders.paymentUpdated': 'Payment status updated',
    'orders.benefitUpdated': 'Benefit updated',
    'orders.updateFailed': 'Update failed',
    'orders.createSuccess': 'Order created',
    'orders.createFailed': 'Order creation failed',
    // User-facing
    'orders.myOrdersTitle': 'My Orders & Benefits',
    'orders.myOrdersSubtitle': 'View your tool submission orders and earned benefits',
    'orders.activeBenefitsTitle': 'My Active Benefits',
    'orders.pendingHint': 'You have {count} orders pending payment',
    'orders.goToPay': 'Go to Pay',
    'orders.allOrders': 'All Orders',
    'orders.noOrders': 'No orders yet. Submit your AI tool now!',
    'orders.submitTool': 'Submit Tool',
    'orders.viewTool': 'View Tool',
    'orders.expiringIn': 'Expiring in',
    'orders.remaining': 'Remaining',
    'orders.stepSubmitted': 'Submitted',
    'orders.stepPaid': 'Paid',
    'orders.stepActivated': 'Activated',
    'orders.benefitCompare': 'Plan Comparison',
    'orders.benefitFree1': 'Basic listing display',
    'orders.benefitFree2': 'Standard search discoverability',
    'orders.benefitStd1': 'Priority manual review',
    'orders.benefitStd2': '⭐ Standard listing badge',
    'orders.benefitStd3': 'Priority in category ranking',
    'orders.benefitStd4': '30-day validity',
    'orders.benefitPro1': '🏆 Homepage featured display',
    'orders.benefitPro2': '👑 Premium verified badge',
    'orders.benefitPro3': 'Top search results placement',
    'orders.benefitPro4': 'SEO optimization boost',
    'orders.benefitPro5': '365-day validity',
    // Nav
    'nav.myOrders': 'My Orders',

    // ===== Disclaimer =====
    'disclaimer.title': 'Disclaimer',
    'disclaimer.section1Title': '1. Information Sources',
    'disclaimer.section1Content': 'AI tool information on this platform is sourced from public channels, including official tool websites and third-party data platforms (e.g. TopAI.tools). We strive for accuracy but make no guarantees regarding completeness, accuracy, or timeliness. If you find any errors, please submit corrections through the feedback page.',
    'disclaimer.section2Title': '2. China Availability Notes',
    'disclaimer.section2Content': 'The "China Availability" status (e.g. "Direct Access", "Access Restricted", "Mirror Available") is for reference only, based on manual testing or community feedback, and may change due to network conditions. Tools marked "Access Restricted" may be inaccessible in certain network environments. Please consider domestic alternatives or compliant enterprise cross-border solutions. This platform does not provide or recommend any proxy or circumvention services.',
    'disclaimer.section3Title': '3. Third-Party Links',
    'disclaimer.section3Content': 'This platform contains links to third-party websites for your convenience. We are not responsible for their content, privacy policies, or security. Visiting third-party links is at your own risk.',
    'disclaimer.section4Title': '4. Corrections & Feedback',
    'disclaimer.section4Content': 'If you find any errors or have suggestions, please contact us via:',
    'disclaimer.submitLink': 'Correction / Submit Tool page',
    'disclaimer.emailLink': 'Email',
    'disclaimer.effectiveNote': 'This disclaimer is effective from the date of publication. We reserve the right to modify it at any time. Continued use of this platform constitutes acceptance of this disclaimer.',

    // ===== Privacy =====
    'privacy.title': 'Privacy Policy',
    'privacy.section1Title': '1. Information Collection',
    'privacy.section1Content': 'We may collect the following information when you use this platform: registration info (username, email), search history and browsing records, favorites and reviews, basic device and browser info (for experience optimization).',
    'privacy.section2Title': '2. Information Usage',
    'privacy.section2Content': 'Collected information is used only for: personalized recommendations and search history, improving service quality, generating anonymous statistics. We will not sell or share your personal information with third parties unless required by law.',
    'privacy.section3Title': '3. Information Security',
    'privacy.section3Content': 'We take reasonable technical and administrative measures to protect your personal information, including: HTTPS encryption, hashed password storage, access controls. However, no internet transmission is 100% secure.',
    'privacy.section4Title': '4. Cookie Usage',
    'privacy.section4Content': 'This platform uses cookies and local storage to save your login status and language preference. You can manage cookies through browser settings. Disabling cookies may affect some features.',
    'privacy.section5Title': '5. Contact',
    'privacy.section5Content': 'For any questions about this privacy policy, please contact us through the contact page.',
    'privacy.effectiveNote': 'This policy is effective from the date of publication. We reserve the right to update it at any time. Major changes will be announced on the platform.',

    // ===== Submit/Correct =====
    'submit.title': 'Submit AI Tool',
    'submit.description': 'Submit a real product to GlobalAI Tools — listed by job, reviewed before publish.',
    'submit.success': 'Submitted successfully! We will review your tool shortly.',
    'submit.failed': 'Submission failed. Please try again later.',
    'submit.typeLabel': 'Feedback Type',
    'submit.typeRequired': 'Please select a type',
    'submit.typePlaceholder': 'Select...',
    'submit.typeNew': '🆕 Submit New Tool',
    'submit.typeCorrection': '✏️ Correction',
    'submit.typeAvailability': '🏷️ Availability Feedback',
    'submit.typeOther': '💬 Other Feedback',
    'submit.toolNameLabel': 'Tool Name',
    'submit.toolNameRequired': 'Please enter the tool name',
    'submit.toolNamePlaceholder': 'e.g. ChatGPT',
    'submit.toolUrlLabel': 'Tool URL',
    'submit.toolUrlRequired': 'Please enter the tool URL',
    'submit.descriptionLabel': 'Tool Description',
    'submit.descriptionRequired': 'Please enter a description',
    'submit.descriptionPlaceholder': 'Briefly describe the AI tool\'s features, highlights, and target audience…',
    'submit.contactLabel': 'Contact Information',
    'submit.contactRequired': 'Please provide contact info so we can reach you',
    'submit.contactPlaceholder': 'Email / WeChat / Phone',
    'submit.submitButton': 'Submit Free',
    'submit.submitAndPay': 'Submit & Pay',
    'submit.planLabel': 'Select Plan',
    // -- Hero --
    'submit.heroTitle': 'Get Your AI Tool Discovered Worldwide',
    'submit.heroSubtitle': 'Submit a real product to GlobalAI Tools — listed by job, with mainland China access notes. Free submissions are open for manual review.',
    'submit.heroBadge1': '✅ Free Option Available',
    'submit.heroBadge2': '⚡ Manual Review',
    'submit.heroBadge3': '🇨🇳 Access Notes',
    'submit.heroCtaBtn': 'Submit Now',
    // -- Stats --
    'submit.stat1': 'Curated Listing',
    'submit.stat2': 'By Job',
    'submit.stat3': 'CN Access Notes',
    'submit.stat4': 'Human Review',
    'submit.stat1Value': 'By job',
    'submit.stat2Value': 'Filterable',
    'submit.stat3Value': 'Labeled',
    'submit.stat4Value': 'Reviewed',
    // -- Pricing --
    'submit.pricingTitle': 'Choose Your Plan',
    'submit.pricingSubtitle': 'Whether you\'re an indie developer or an enterprise team, find the right promotion plan',
    'submit.popularTag': 'Most Popular',
    'submit.planFreeName': 'Free Listing',
    'submit.planFreePrice': 'Forever',
    'submit.planFreeBtn': 'Apply for Free Listing',
    'submit.planFreeF1': 'Basic tool listing',
    'submit.planFreeF2': 'Standard category inclusion',
    'submit.planFreeF3': 'Searchable in directory',
    'submit.planFreeF4': 'Review in standard queue',
    'submit.planFreeF5': '',
    'submit.planFreeF6': '',
    'submit.planFreeF7': '',
    'submit.planStdName': 'Fast Listing',
    'submit.planStdPrice': 'one-time',
    'submit.planStdBtn': 'Get Listed Faster',
    'submit.planStdF1': 'Priority review within 24–48 hours',
    'submit.planStdF2': 'Faster publishing to directory',
    'submit.planStdF3': 'Better visibility in search & category',
    'submit.planStdF4': 'Verified badge on your listing',
    'submit.planStdF5': '',
    'submit.planStdF6': '',
    'submit.planStdF7': '',
    'submit.planProName': 'Homepage Featured',
    'submit.planProPrice': '7 days',
    'submit.planProBtn': 'Get Homepage Exposure',
    'submit.planProF1': 'Homepage featured placement for 7 days',
    'submit.planProF2': 'Higher ranking in category & search',
    'submit.planProF3': 'Faster review and publishing',
    'submit.planProF4': 'Premium visibility badge',
    'submit.planProF5': 'Dofollow backlink',
    'submit.planProF6': '',
    'submit.planProF7': '',
    // -- Comparison --
    'submit.cmpTitle': 'Plan Feature Comparison',
    'submit.cmpFeature': 'Feature',
    'submit.cmpRow1': 'Basic Listing',
    'submit.cmpRow2': 'Review Time',
    'submit.cmpRow3': 'Dofollow Backlink',
    'submit.cmpRow4': 'Verified Badge',
    'submit.cmpRow5': 'Homepage Featured',
    'submit.cmpRow6': 'Social Media Promotion',
    'submit.cmpRow7': 'Top Search Results',
    'submit.cmpRow8': 'Dedicated Support',
    'submit.cmpDays': 'business days',
    'submit.cmpImmediate': 'Within 1 hour',
    // -- How It Works --
    'submit.howTitle': 'How It Works',
    'submit.howSubtitle': 'Four simple steps to get your tool discovered by users worldwide',
    'submit.step1Title': 'Choose a Plan',
    'submit.step1Desc': 'Fill in your tool details and submit for free',
    'submit.step2Title': 'Fill in Details',
    'submit.step2Desc': 'Provide tool name, URL, description, and other basic info',
    'submit.step3Title': 'Review & List',
    'submit.step3Desc': 'Our team will quickly review and list your tool',
    'submit.step4Title': 'Get Exposure',
    'submit.step4Desc': 'Once live, start getting traffic from users worldwide',
    // -- Benefits --
    'submit.whyTitle': 'Why Choose GlobalAI Tools?',
    'submit.whySubtitle': 'We provide the most comprehensive promotion solutions for AI tool developers and enterprises',
    'submit.benefit1Title': 'Massive Targeted Traffic',
    'submit.benefit1Desc': 'Hundreds of thousands of active users search for AI tools on our platform every month, reaching your target audience directly',
    'submit.benefit2Title': 'Professional Brand Endorsement',
    'submit.benefit2Desc': 'Listed tools get ratings, reviews, and verified badges, significantly boosting brand trust',
    'submit.benefit3Title': 'SEO Organic Traffic',
    'submit.benefit3Desc': 'SEO-optimized dedicated pages continuously bring free search engine traffic to your product',
    'submit.benefit4Title': 'China Market Access',
    'submit.benefit4Desc': 'China availability labeling and compliance certification help tools quickly enter the Chinese market',
    'submit.benefit5Title': 'High-Quality Backlinks',
    'submit.benefit5Desc': 'Paid plans include Dofollow backlinks that effectively boost your website\'s SEO authority and ranking',
    'submit.benefit6Title': 'Community Promotion',
    'submit.benefit6Desc': 'Homepage Featured plan includes multi-channel social media promotion, reaching more potential users',
    // -- Trust --
    'submit.trustTitle': 'Trusted by Thousands',
    'submit.trust1': 'Data Security',
    'submit.trust2': '24/7 Support',
    'submit.trust3': '500+ Tools Served',
    'submit.trust4': 'Global Coverage',
    // -- Payment --
    'submit.paymentNotice': 'After submission you will be redirected to the payment page. Once payment is complete, your tool enters the priority review queue. We accept credit cards and PayPal.',
    // -- Form --
    'submit.formTitle': 'Submit Your Tool',
    'submit.formSubtitle': 'Fill in the details below to start your global promotion journey',
    'submit.categoryLabel': 'Category',
    'submit.categoryPlaceholder': 'Select a category (optional)',
    'submit.catWriting': '✍️ AI Writing',
    'submit.catImage': '🎨 AI Art / Image',
    'submit.catVideo': '🎬 AI Video',
    'submit.catCode': '💻 AI Coding',
    'submit.catChat': '🤖 AI Chatbot',
    'submit.catProductivity': '📊 AI Productivity',
    'submit.catOther': '📦 Other',
    // -- Extended form fields --
    'submit.section.basic': 'Basic Info',
    'submit.section.description': 'Detailed Description',
    'submit.section.pricing': 'Pricing',
    'submit.section.cnAvailability': 'China Availability',
    'submit.section.enterprise': 'Enterprise Procurement',
    'submit.section.discount': 'Platform Exclusive Offers',
    'submit.section.contact': 'Contact & Tags',
    'submit.nameEnLabel': 'English Name',
    'submit.nameEnPlaceholder': 'e.g. ChatGPT',
    'submit.nameZhLabel': 'Chinese Name',
    'submit.nameZhPlaceholder': 'e.g. 智谱清言',
    'submit.shortDescLabel': 'Short Description',
    'submit.shortDescPlaceholder': 'Briefly describe the core feature, max 100 chars',
    'submit.shortDescRequired': 'Please enter a short description',
    'submit.descEnLabel': 'English Description',
    'submit.descEnPlaceholder': 'Tool description in English…',
    'submit.descZhLabel': 'Chinese Description',
    'submit.descZhPlaceholder': 'Tool description in Chinese…',
    'submit.logoLabel': 'Logo (1:1 Square)',
    'submit.logoPlaceholder': 'https://example.com/logo.png',
    'submit.showcaseLabel': 'Showcase Image (16:9)',
    'submit.showcasePlaceholder': 'https://example.com/screenshot.png',
    'submit.apiDocLabel': 'API Documentation URL',
    'submit.apiDocPlaceholder': 'https://docs.example.com/api',
    'submit.pricingTypeLabel': 'Pricing Model',
    'submit.pricingTypeFree': 'Free',
    'submit.pricingTypeFreemium': 'Freemium',
    'submit.pricingTypePaid': 'Paid',
    'submit.pricingTypeContact': 'Contact Sales',
    'submit.pricingDetailLabel': 'Pricing Details',
    'submit.pricingDetailPlaceholder': 'e.g. Free basic, Pro $20/mo',
    'submit.cnUrlLabel': 'China Access URL',
    'submit.cnUrlPlaceholder': 'https://cn.example.com',
    'submit.cnIcpLabel': 'ICP License Number',
    'submit.cnIcpPlaceholder': 'e.g. 京ICP备XXXXXXXX号',
    'submit.cnAppStoreLabel': 'Available in China App Store',
    'submit.cnWechatMiniLabel': 'Has WeChat Mini Program',
    'submit.cnAltNamesLabel': 'China Alternative Names',
    'submit.cnAltNamesPlaceholder': 'Alternative product names in China, comma separated',
    'submit.invoiceLabel': 'Supports Invoice',
    'submit.contractLabel': 'Supports Contract',
    'submit.onPremLabel': 'Supports On-Premise Deployment',
    'submit.procurementChannelLabel': 'Procurement Channel',
    'submit.procurementDirect': 'Direct',
    'submit.procurementReseller': 'Reseller',
    'submit.procurementMarketplace': 'Cloud Marketplace',
    'submit.procurementOpensource': 'Open Source',
    'submit.procurementContactLabel': 'Procurement Contact',
    'submit.procurementContactPlaceholder': 'Procurement email or phone',
    'submit.minSeatsLabel': 'Minimum Seats',
    'submit.minSeatsPlaceholder': 'e.g. 5',
    'submit.enterpriseFeaturesLabel': 'Enterprise Features',
    'submit.enterpriseFeaturesPlaceholder': 'e.g. SSO, Audit Logs, Custom Domain (comma separated)',
    'submit.hasDiscountLabel': 'Offer exclusive discount for our users?',
    'submit.discountDescLabel': 'Discount Description',
    'submit.discountDescPlaceholder': 'e.g. 20% off first year, 50 free API calls',
    'submit.couponCodeLabel': 'Coupon / Promo Code',
    'submit.couponCodePlaceholder': 'e.g. GLOBALAI20',
    'submit.discountUrlLabel': 'Exclusive Discount Link',
    'submit.discountUrlPlaceholder': 'Registration/purchase link with discount, e.g. https://example.com/?ref=globalai',
    // -- FAQ --
    'submit.faqTitle': 'Frequently Asked Questions',
    'submit.faq1Q': 'What\'s the difference between free and paid listings?',
    'submit.faq1A': 'Only free listing is open: submit your tool, we review it manually, then publish it in the directory. Paid boost / homepage featured is temporarily unavailable.',
    'submit.faq2Q': 'How soon will my tool go live?',
    'submit.faq2A': 'Free submissions are usually reviewed within several business days, depending on queue volume.',
    'submit.faq3Q': 'Is listing free right now?',
    'submit.faq3A': 'Yes — free submit and manual review only. Paid listing and online payment will return later.',
    'submit.faq4Q': 'What happens after the 7-day Homepage Featured expires?',
    'submit.faq4A': 'Yes. Once approved, your tool stays in the directory. Paid featured placement details will be announced when that product returns.',
    'submit.faq5Q': 'Can I submit my own tool?',
    'submit.faq5A': 'Absolutely! We welcome developers and enterprises to submit their own AI tools. It\'s a great way to gain early users and market feedback.',
    'submit.faq6Q': 'Can I get a refund if not satisfied?',
    'submit.faq6A': 'Full refund if your tool doesn\'t pass review. Pro-rated refund within the first 48 hours for active benefits.',
    // -- Final CTA --
    'submit.ctaTitle': 'Ready to Get Your AI Tool Discovered Worldwide?',
    'submit.ctaDesc': 'Submit a real product — after review it appears in the job-first directory',
    'submit.ctaBtn': 'Submit Your Tool Now',

    // ===== Payment =====
    'payment.title': 'Choose Payment Method',
    'payment.subtitle': 'Complete your payment to activate your listing benefits',
    'payment.planFree': 'Free Listing',
    'payment.planStandard': 'Fast Listing',
    'payment.planPremium': 'Homepage Featured',
    'payment.selectMethod': 'Select Payment Method',
    'payment.scanTip': 'Complete your payment using the selected method',
    'payment.amountLabel': 'Amount Due',
    'payment.stepsTitle': 'Payment Process',
    'payment.step1Title': 'Pay',
    'payment.step1Desc': 'Complete payment via PayPal or your preferred method',
    'payment.step2Title': 'Save Receipt',
    'payment.step2Desc': 'Save your transaction ID or payment confirmation',
    'payment.step3Title': 'Submit Reference',
    'payment.step3Desc': 'Submit your payment reference after payment',
    'payment.step4Title': 'Activation',
    'payment.step4Desc': 'Your order will be activated after confirmation',
    'payment.noticeTitle': 'Important',
    'payment.supportTitle': 'Need Help?',
    'payment.supportDesc': 'For payment issues, contact: xinle@quanqiuai.com.sn',
    'payment.copyEmail': 'Copy Email',
    'payment.emailCopied': 'Email copied to clipboard',
    'payment.guarantee1': 'Secure Payment',
    'payment.guarantee2': '24/7 Support',
    'payment.guarantee3': 'Full Refund if Not Approved',

    // ===== Pricing =====
    'pricing.title': 'Submit Your AI Tool',
    'pricing.subtitle': 'Get discovered by AI tool users, founders, and early adopters.',
    'pricing.perMonth': '/mo',
    'pricing.perYear': '/yr',
    'pricing.currentPlan': 'Current Plan',
    'pricing.choosePlan': 'Choose Plan',
    'pricing.contactSales': 'Contact Sales',
    'pricing.popular': 'Most Popular',
    'pricing.freeFeatures': 'Basic tool listing,Standard category inclusion,Searchable in directory,Standard review queue',
    'pricing.standardFeatures': 'Priority review within 24–48h,Faster publishing,Better visibility in search,Verified badge',
    'pricing.premiumFeatures': 'Homepage featured 7 days,Higher search ranking,Faster review,Premium badge,Dofollow backlink',
    'pricing.faq': 'FAQ',
    'pricing.faq1q': 'How soon will my tool go live?',
    'pricing.faq1a': 'Free: 3–5 business days. Fast Listing: within 24–48 hours. Homepage Featured: same-day review.',
    'pricing.faq2q': 'Are paid plans available?',
    'pricing.faq2a': 'Not currently. Free listing only — submit and we review manually. Paid plans return after payment setup is ready.',
    'pricing.faq3q': 'Can I get a refund?',
    'pricing.faq3a': 'Full refund if your tool doesn\'t pass review. Pro-rated refund within 48 hours for active benefits.',

    // ===== Checkout =====
    'checkout.title': 'Checkout',
    'checkout.orderInfo': 'Order Info',
    'checkout.plan': 'Plan',
    'checkout.amount': 'Amount',
    'checkout.toolName': 'Tool Name',
    'checkout.toolNamePlaceholder': 'Enter your AI tool name or URL',
    'checkout.contact': 'Contact Email',
    'checkout.contactPlaceholder': 'Your email for order updates',
    'checkout.note': 'Note',
    'checkout.notePlaceholder': 'Optional notes or special requirements',
    'checkout.createOrder': 'Place Order',
    'checkout.payNow': 'I have paid — submit reference',
    'checkout.orderCreated': 'Order created successfully',
    'checkout.orderNo': 'Order No.',
    'checkout.expiresIn': 'Please complete payment within {time}',
    'checkout.paymentRef': 'Payment Reference',
    'checkout.paymentRefPlaceholder': 'Transaction ID or PayPal reference',
    'checkout.submitted': 'Payment reference submitted. We will verify and activate your order.',
    'checkout.viewMyOrders': 'View My Orders',

    // ===== Contact =====
    'contact.title': 'Contact Us',
    'contact.subtitle': 'For any questions or suggestions, feel free to reach us through the following channels.',
    'contact.emailTitle': 'Email',
    'contact.emailDesc': 'Response within 24 hours on business days',
    'contact.feedbackTitle': 'Corrections & Feedback',
    'contact.feedbackDesc': 'Found incorrect info or want to suggest a tool',
    'contact.feedbackLink': 'Go to Feedback Page →',
    'contact.githubDesc': 'Open source project',
  },
};
